{
    "cli": {
        "compileRemoved": "compile 功能已移除；不再支持 `magic-md compile ...` 或 `magic-md <file>`。CLI 现在只提供 connect 与 completion。",
        "usage": "Commands:\n  connect                    启动本地 Engine Gateway（供 Web 前端连接）\n  completion <bash|zsh|fish> 输出 shell 自动补全脚本\n  help                       显示帮助\n  -v, --version              显示版本信息\n\nConnect Options:\n      --port <port>          监听端口（默认读取 gateway.toml，否则 3721）\n      --host <host>          监听地址（默认读取 gateway.toml，否则 127.0.0.1）\n      --lan                  监听局域网并通过 Bonjour 供 Magic MD Play 自动发现\n      --dir <dir>            Engine 工作目录（默认当前目录）\n      --docs-dir <dir>       文档/工作区目录（作为允许访问根目录）\n      --no-implicit-workspace 不把 --dir 自动暴露为允许访问根目录\n      --token <token>        启用 Bearer Token 认证\n      --allow-sidecar <id>   允许的 sidecar（可多次指定，不指定则全部允许）\n      --cloud-plugin-source <source> 云插件源 URL 或 JSON 对象（可多次指定）"
    },
    "editor": {
        "app.commandPalette": "命令面板",
        "appLog.crossWindowSyncInitFailed": "跨窗口同步初始化失败: {message}",
        "appLog.detachedReceivedTabTransfer": "DetachedWindow: 收到 tab 转移 \"{title}\"",
        "appLog.engine.connectFailed": "Engine 连接失败: {message}",
        "appLog.engine.connecting": "正在连接 Engine ({mode})...",
        "appLog.engine.devConnectFailed": "开发模式 Engine 连接失败: {message}",
        "appLog.engine.devWaiting": "开发模式: 等待 Engine 自动启动...",
        "appLog.engine.startFailed": "Engine 启动失败: {message}",
        "appLog.engineNotConfigured": "Engine 未配置，请在侧边栏底部配置 Engine 连接",
        "appLog.engineStateChangedReloadPlugins": "引擎状态变更，重新加载插件 (mode={mode}, connected={connected})",
        "appLog.loadPlugins.builtinLocalDir": "内置模式: 从本地目录加载插件: {path}",
        "appLog.loadPlugins.builtinMissingEngineDir": "内置模式但 engineDir 未配置",
        "appLog.loadPlugins.devSource": "开发模式: 从源码加载插件",
        "appLog.loadPlugins.devUnsupported": "生产构建中不支持 dev 模式源码加载，请切换到 builtin 或 local",
        "appLog.loadPlugins.gateway": "远程模式: 从 Gateway 加载插件: {url}",
        "appLog.loadPlugins.noGatewayPlugins": "Gateway 无可用插件",
        "appLog.loadPlugins.noLocalPlugins": "未找到本地插件",
        "appLog.loadPlugins.nonePreviewSource": "未配置引擎，从源码加载插件（预览模式）",
        "appLog.mainReceivedTabTransfer": "主窗口: 收到 tab 转移 \"{title}\"",
        "appLog.mode.builtin": "内置模式",
        "appLog.mode.local": "本地模式",
        "appLog.web.loadPlugins.devSource": "开发模式: 从源码加载插件 UI，Engine 仍使用当前连接",
        "appLog.web.loadPlugins.gateway": "从 Gateway 加载插件: {url}",
        "appLog.web.loadPlugins.noGatewayPlugins": "Gateway 无可用插件，请确保 Gateway 正在运行且插件已构建",
        "category.file": "文件",
        "category.general": "通用",
        "category.pane": "Pane",
        "category.plugin": "插件",
        "category.search": "搜索",
        "category.sidebar": "侧边栏",
        "category.view": "视图",
        "command.empty": "没有找到命令",
        "command.file.clearRecent": "清除最近项目",
        "command.file.closeAllTabs": "关闭所有标签",
        "command.file.closeTab": "关闭标签",
        "command.file.new": "新建文件",
        "command.file.nextTab": "下一个标签",
        "command.file.open": "打开文件",
        "command.file.prevTab": "上一个标签",
        "command.file.save": "保存",
        "command.file.saveAs": "另存为...",
        "command.palette.open": "命令面板",
        "command.pane.close": "关闭 Pane",
        "command.pane.focusNext": "聚焦下一个 Pane",
        "command.pane.focusPrev": "聚焦上一个 Pane",
        "command.pane.splitDown": "向下拆分 Pane",
        "command.pane.splitRight": "向右拆分 Pane",
        "command.placeholder": "输入命令...",
        "command.plugin.clearAll": "清除所有输出",
        "command.plugin.runAll": "运行所有插件",
        "command.plugin.stopAll": "停止所有插件",
        "command.search.focus": "在文件中搜索",
        "command.settings.open": "打开设置",
        "command.sidebar.engine": "显示 Engine",
        "command.sidebar.explorer": "显示资源管理器",
        "command.sidebar.files": "显示打开的文件",
        "command.sidebar.installedPlugins": "显示已安装插件",
        "command.sidebar.plugins": "在资源管理器中显示插件实例",
        "command.sidebar.sidecars": "显示 Sidecars",
        "command.sidebar.toc": "显示大纲",
        "command.view.editor": "仅编辑器",
        "command.view.preview": "仅预览",
        "command.view.split": "分栏视图",
        "command.view.toggleDarkMode": "切换主题",
        "command.view.toggleLogPanel": "切换日志面板",
        "command.view.toggleRightSidebar": "切换右侧边栏",
        "command.view.toggleSidebar": "切换侧边栏",
        "command.view.toggleSyntaxHoverDetail": "切换语法悬浮详情",
        "command.view.toggleWidgetMode": "切换 Widget 模式 (L0 <-> L2)",
        "command.workspace.close": "关闭工作区",
        "command.workspace.open": "打开工作区",
        "command.workspace.save": "保存工作区",
        "common.active": "当前活动",
        "common.action": "操作",
        "common.actions": "操作",
        "common.all": "全部",
        "common.arguments": "参数",
        "common.back": "返回",
        "common.capabilities": "能力",
        "common.cancel": "取消",
        "common.close": "关闭",
        "common.collapse": "折叠",
        "common.config": "配置",
        "common.copy": "复制",
        "common.copied": "已复制！",
        "common.current": "当前",
        "common.default": "默认",
        "common.description": "描述",
        "common.delete": "删除",
        "common.dependencies": "依赖",
        "common.error": "错误",
        "common.expand": "展开",
        "common.invalidJson": "JSON 格式错误",
        "common.loading": "加载中...",
        "common.listSeparator": "，",
        "common.name": "名称",
        "common.none": "暂无",
        "common.notFound": "未找到",
        "common.open": "打开",
        "common.optional": "可选",
        "common.paste": "粘贴",
        "common.preview": "预览",
        "common.parameters": "参数",
        "common.refresh": "刷新",
        "common.rename": "重命名",
        "common.required": "必填",
        "common.request": "请求",
        "common.response": "响应",
        "common.reset": "重置",
        "common.retry": "重试",
        "common.running": "运行中",
        "common.run": "运行",
        "common.save": "保存",
        "common.stop": "停止",
        "common.status": "状态",
        "common.progress": "进度",
        "common.startTime": "开始时间",
        "common.duration": "耗时",
        "common.output": "输出",
        "common.clear": "清除",
        "common.type": "类型",
        "common.unlimited": "不限",
        "common.unknown": "未知",
        "common.untitled": "未命名",
        "common.yes": "是",
        "common.no": "否",
        "document.activity.failed": "执行失败",
        "document.activity.mcpClient": "MCP 客户端",
        "document.activity.read": "正在读取",
        "document.activity.completed": "已完成",
        "document.activity.execute": "正在执行",
        "document.activity.externalEditor": "外部编辑器",
        "document.activity.unknownSource": "未知来源",
        "document.activity.write": "已写入",
        "document.path": "文档路径",
        "document.unsaved": "未保存",
        "annotation.areaComment": "区域评论",
        "annotation.addBlockComment": "添加块级评论",
        "annotation.addLocationComment": "添加位置评论",
        "annotation.action.resolve": "解决",
        "annotation.areaPointCommentPlaceholder": "添加点位或区域评论，输入 @、# 或 /",
        "annotation.blockCommentPlaceholder": "添加块级评论，输入 @、# 或 /",
        "annotation.cancelLocationComment": "取消位置评论",
        "annotation.commentCandidates": "评论候选",
        "annotation.commentPlaceholder": "添加评论，输入 @、# 或 /",
        "annotation.confirmDelete": "删除「{name}」annotation? 此操作不会删除源 Markdown 文件。",
        "annotation.confirmDeleteGroup": "删除「{name}」中的全部 annotation? 此操作不会删除源 Markdown 文件。",
        "annotation.confirmDeletePackage": "删除「{name}」annotation 包? 此操作不会删除源 Markdown 文件。",
        "annotation.continueCommentPlaceholder": "继续评论，输入 @、# 或 /",
        "annotation.delete": "删除 Annotation",
        "annotation.deleteComment": "删除评论",
        "annotation.deleteGroup": "删除本组 Annotation",
        "annotation.deletePackage": "删除 Annotation 包",
        "annotation.edit": "编辑",
        "annotation.editComment": "编辑评论",
        "annotation.elementCommentPlaceholder": "添加元素评论，输入 @、# 或 /",
        "annotation.elementComment": "元素评论",
        "annotation.goToSource": "跳到源码",
        "annotation.locatePreview": "定位到 Preview",
        "annotation.markResolved": "标记解决",
        "annotation.noMatches": "无匹配项",
        "annotation.palette.mention": "提及",
        "annotation.palette.tag": "标签",
        "annotation.palette.template": "模板",
        "annotation.placementHint": "拖拽选择区域，或点击元素/点位",
        "annotation.pointComment": "点位评论",
        "annotation.rebindPrompt": "选择新的文本位置以重新绑定批注",
        "annotation.rebindToSelection": "重新绑定到选区",
        "annotation.reopen": "恢复为未解决",
        "annotation.reply": "回复",
        "annotation.replyComment": "回复评论",
        "annotation.replyCommentPlaceholder": "回复评论，输入 @、# 或 /",
        "annotation.resolveAllInGroup": "本组全部标记解决",
        "annotation.retryLocate": "重试定位",
        "annotation.saveEdit": "保存编辑",
        "annotation.source": "源码",
        "annotation.status.commentAdded": "评论已添加",
        "annotation.status.commentDeleted": "评论已删除",
        "annotation.status.commentUpdated": "评论已更新",
        "annotation.status.deleted": "Annotation 已删除",
        "annotation.status.groupDeleted": "本组 Annotation 已删除",
        "annotation.status.groupResolved": "本组 Annotation 已全部标记解决",
        "annotation.status.markedResolved": "Annotation 已标记解决",
        "annotation.status.packageDeleted": "Annotation 包已删除",
        "annotation.status.packageDeleteFailed": "删除 Annotation 包失败: {message}",
        "annotation.status.persistFailed": "保存 annotation 失败: {message}",
        "annotation.status.reboundToSelection": "Annotation 已重新绑定到当前选区",
        "annotation.status.reopened": "Annotation 已恢复为未解决",
        "annotation.status.replyAdded": "回复已添加",
        "annotation.status.retryingLocate": "已打开 Preview，正在重试定位 Annotation",
        "annotation.style.comment": "评论",
        "annotation.style.highlight": "高亮",
        "annotation.style.underline": "划线",
        "annotation.viewAreaComment": "查看区域评论",
        "annotation.viewBlockComment": "查看块级评论",
        "annotation.viewElementComment": "查看元素评论",
        "annotation.composer.command.ask": "插入问题模板",
        "annotation.composer.command.decision": "插入决策说明",
        "annotation.composer.command.quote": "插入引用说明",
        "annotation.composer.command.resolve": "插入解决说明",
        "annotation.composer.command.risk": "插入风险说明",
        "annotation.composer.command.source": "插入来源说明",
        "annotation.composer.command.todo": "插入待办模板",
        "annotation.composer.definition": "引用实例",
        "annotation.composer.executedDefinition": "引用已执行实例",
        "annotation.composer.insert.ask": "问题：",
        "annotation.composer.insert.decision": "结论：",
        "annotation.composer.insert.quote": "引用：",
        "annotation.composer.insert.resolve": "已处理：",
        "annotation.composer.insert.risk": "风险：",
        "annotation.composer.insert.source": "来源：",
        "annotation.composer.insert.todo": "TODO：",
        "annotation.composer.keywords.ask": "问题|疑问|question",
        "annotation.composer.keywords.decision": "结论|决策|方案",
        "annotation.composer.keywords.followUp": "后续|追踪",
        "annotation.composer.keywords.question": "疑问|确认",
        "annotation.composer.keywords.quote": "引用|原文",
        "annotation.composer.keywords.resolve": "解决|完成|done",
        "annotation.composer.keywords.risk": "风险|阻塞",
        "annotation.composer.keywords.source": "来源|出处|引用",
        "annotation.composer.keywords.todo": "待办|任务",
        "annotation.composer.tag.decision": "决策",
        "annotation.composer.tag.followUp": "跟进",
        "annotation.composer.tag.question": "问题",
        "annotation.composer.tag.risk": "风险",
        "annotation.composer.tag.source": "来源",
        "annotation.composer.tag.todo": "待处理",
        "dialog.addCurrentFolderToFavorites": "将当前文件夹加入收藏",
        "dialog.allowedRoots": "允许的根目录",
        "dialog.clearRecents": "清除最近记录",
        "dialog.confirm": "确认",
        "dialog.dragFoldersHere": "将文件夹拖到这里",
        "dialog.dropToAdd": "松开添加",
        "dialog.enterAllowedPath": "输入允许的路径...",
        "dialog.favorites": "收藏",
        "dialog.fileName": "文件名：",
        "dialog.goToPath": "跳转到路径...",
        "dialog.noAccessibleRoots": "当前没有可访问的目录根，请先在 Settings 中配置允许操作的目录。",
        "dialog.noAllowedRoots": "暂无允许的根目录",
        "dialog.noRecentFolders": "暂无最近文件夹",
        "dialog.noRecentWorkspaces": "暂无最近工作区",
        "dialog.openFailed": "打开失败: {message}",
        "dialog.openFile": "打开文件",
        "dialog.openFolder": "打开文件夹",
        "dialog.openingFolder": "正在打开文件夹...",
        "dialog.openingWorkspace": "正在打开工作区...",
        "dialog.pathOutsideAllowedRoots": "该路径不在允许的目录范围内",
        "dialog.recents": "最近目录",
        "dialog.recentWorkspaces": "最近打开的工作区",
        "dialog.saveFile": "保存文件",
        "dialog.selectFolder": "选择文件夹",
        "workspace.action.move": "移动",
        "workspace.action.rename": "重命名",
        "workspace.confirmDelete.message": "确定要删除{label}「{name}」吗？此操作不可撤销。",
        "workspace.confirmDelete.title": "删除{label}",
        "workspace.confirmDeleteReferenced.confirm": "仍然删除",
        "workspace.confirmDeleteReferenced.footer": "删除不会自动移除引用文本，相关文档之后会显示缺失引用诊断。",
        "workspace.confirmDeleteReferenced.message": "删除{label}「{name}」会导致 {count} 处引用失效。",
        "workspace.confirmDeleteReferenced.title": "删除被引用的文件",
        "workspace.error.openFolderEngine": "Engine 未能打开文件夹",
        "workspace.error.loadWorkspaceEngine": "Engine 未能加载工作区",
        "workspace.error.noFolders": "工作区文件没有包含任何文件夹",
        "workspace.label.file": "文件",
        "workspace.label.folder": "文件夹",
        "workspace.references.actionAndUpdate": "{action}并更新引用",
        "workspace.references.footerNote": "继续后，无法自动更新的引用可能会失效。",
        "workspace.references.impactTitle": "引用影响",
        "workspace.references.remaining.description": "打开引用诊断后可以继续查看完整列表。",
        "workspace.references.remaining.title": "还有 {count} 处引用",
        "workspace.references.stillAction": "仍然{action}",
        "workspace.references.updateSafe.message": "{action}会更新 {count} 处引用。",
        "workspace.references.updateTitle": "更新引用",
        "workspace.references.updateUnsafe.message": "{action}会影响 {count} 处引用，其中部分引用无法自动更新。",
        "workspace.status.addAssetFileFailed": "创建 assets 文件失败",
        "workspace.status.addAssetFolderFailed": "创建 assets 文件夹失败",
        "workspace.status.addFolderFailed": "创建文件夹失败",
        "workspace.status.assetFileCreated": "已创建 assets 文件: {name}",
        "workspace.status.assetFolderCreated": "已创建 assets 文件夹: {name}",
        "workspace.status.clipboardEmpty": "剪贴板为空",
        "workspace.status.closeFailed": "关闭工作区失败: {message}",
        "workspace.status.closed": "已关闭工作区",
        "workspace.status.copyPathFailed": "复制路径失败",
        "workspace.status.copyPathSucceeded": "已复制路径",
        "workspace.status.copied": "已复制: {name}",
        "workspace.status.deleteFailed": "删除失败: {name}",
        "workspace.status.deleted": "已删除: {name}",
        "workspace.status.fileCreated": "已创建文件: {name}",
        "workspace.status.fileCreateFailed": "创建文件失败",
        "workspace.status.fileExists": "文件已存在: {name}",
        "workspace.status.fileNameInvalid": "文件名无效",
        "workspace.status.folderAdded": "已添加文件夹: {name}",
        "workspace.status.folderAddFailed": "添加文件夹失败: {message}",
        "workspace.status.folderExists": "文件夹已存在: {name}",
        "workspace.status.folderNameInvalid": "文件夹名无效",
        "workspace.status.folderOpened": "已打开文件夹: {name}",
        "workspace.status.folderOpenFailed": "打开文件夹失败: {message}",
        "workspace.status.folderRemoved": "已移除文件夹: {name}",
        "workspace.status.folderRemoveFailed": "移除文件夹失败: {message}",
        "workspace.status.folderReadFailed": "读取文件夹失败",
        "workspace.status.loadFailed": "加载工作区失败: {message}",
        "workspace.status.loaded": "已加载工作区: {name}",
        "workspace.status.moved": "已移动: {name}",
        "workspace.status.movedMany": "已移动 {count} 个项目",
        "workspace.status.movedWithReferences": "已移动 {count} 个项目，并更新 {references} 处引用",
        "workspace.status.moveFailed": "移动失败: {message}",
        "workspace.status.movePartial": "已移动 {moved}/{total} 个项目；其余移动失败: {message}",
        "workspace.status.moveDestinationChanged": "移动目标在确认后发生变化（预期 {expected}，实际 {actual}），已取消该项移动",
        "workspace.status.bundleMoveStateChanged": "移动期间配套数据目录状态发生变化: {name}",
        "workspace.status.movedReferenceUpdateFailed": "已移动 {count} 个项目，但更新引用失败: {message}",
        "workspace.status.pasted": "已粘贴: {name}",
        "workspace.status.pasteFailed": "粘贴失败",
        "workspace.status.renameFailed": "重命名失败",
        "workspace.status.renamed": "已重命名为: {name}",
        "workspace.status.renamedWithReferences": "已重命名为: {name}，并更新 {references} 处引用",
        "workspace.status.saveFailed": "保存工作区失败: {message}",
        "workspace.status.saved": "已保存工作区: {name}",
        "workspace.status.starFailed": "收藏失败: {message}",
        "workspace.status.targetBundleExists": "目标资源包已存在: {name}",
        "workspace.status.targetExists": "目标已存在: {name}",
        "tabs.confirm.externalChange.message": "\"{title}\" 已被外部修改。是否重新加载？（会丢失未保存的更改）",
        "tabs.confirm.externalChange.title": "文件已在外部更改",
        "tabs.status.autoReloadFailed": "重新加载文件失败",
        "tabs.status.autoReloaded": "已自动重新加载: {title}",
        "tabs.status.doctorNoSave": "Doctor 面板无需保存",
        "tabs.status.doctorNoSaveAs": "Doctor 面板无需另存为",
        "tabs.status.fileSaved": "已保存: {title}",
        "tabs.status.icloudNotDownloaded": "文件存储在 iCloud 中且尚未下载，请在 Finder 中下载后重试",
        "tabs.status.noWorkspaceLoaded": "当前没有已加载的 .mdspace 工作区",
        "tabs.status.opened": "已打开: {title}",
        "tabs.status.openFailed": "打开文件失败: {message}",
        "tabs.status.openedDoctor": "已打开 Doctor: {name}",
        "tabs.status.openedWorkspaceConfig": "已打开工作区配置: {title}",
        "tabs.status.saveAsFailed": "另存为失败",
        "tabs.status.savedAs": "已另存为: {title}",
        "tabs.status.saveFailed": "保存失败",
        "tabs.status.workspaceConfigSaved": "已保存工作区配置",
        "menubar.backgroundDocument": "后台文档 {id}",
        "menubar.contentRunning": "Content 运行中",
        "menubar.currentDocument": "当前文档",
        "menubar.currentUnit": "当前: {id}",
        "menubar.documentPublish": "文档发布",
        "menubar.folder": "文件夹",
        "menubar.forRunning": "For 运行中",
        "menubar.importRunning": "Import 运行中",
        "menubar.moveToNewWindow": "移动到新窗口",
        "menubar.pinToMenuBar": "固定到菜单栏",
        "menubar.pinned": "已固定到菜单栏: {title}",
        "menubar.pinnedDirty": "已固定到菜单栏；预览读取磁盘版本，未保存修改不会显示",
        "menubar.publishRunning": "发布中",
        "menubar.runAllRunning": "批量运行中",
        "menubar.running": "运行中",
        "menubar.sitePublish": "站点发布",
        "menubar.unpinFromMenuBar": "从菜单栏取消固定",
        "menubar.unpinned": "已从菜单栏取消固定: {title}",
        "menubar.useRunning": "Use 运行中",
        "pinned.backToDocumentList": "返回文档列表",
        "pinned.cancelTask": "取消任务",
        "pinned.emptyDocuments": "暂无固定文档",
        "pinned.fixedDocument": "固定文档",
        "pinned.fixedDocuments": "固定文档",
        "pinned.hiddenDocuments": "还有 {count} 个固定文档",
        "pinned.hiddenSidecars": "还有 {count} 个 Sidecar 运行中",
        "pinned.hiddenTasks": "还有 {count} 个任务正在运行",
        "pinned.hiddenWorkspaces": "还有 {count} 个工作区",
        "pinned.loadingDocument": "正在加载文档...",
        "pinned.noRunningSidecars": "暂无运行中的 Sidecar",
        "pinned.openInEditor": "在 Editor 中打开",
        "pinned.quickAccess": "快速访问",
        "pinned.readDocumentFailed": "读取文档失败: {message}",
        "pinned.recentWorkspaces": "最近工作区",
        "pinned.refreshStatus": "刷新状态",
        "pinned.runtime": "运行环境",
        "pinned.runningSidecars": "运行中的 Sidecars",
        "pinned.sidecarsRunning": "{count} 个运行中",
        "pinned.runningTasks": "正在运行",
        "pinned.showMainWindow": "显示主窗口",
        "pinned.startMcp": "启动 MCP",
        "pinned.stopMcp": "停止 MCP",
        "pinned.unpin": "取消固定",
        "detached.moveBackToMain": "移回主窗口",
        "instance.availablePlugins": "可用插件",
        "instance.detailTitle": "实例详情",
        "instance.notFound.detail": "它可能已经从文档中被移除。",
        "instance.notFound.title": "实例 “{id}” 未找到",
        "instance.pluginMissing": "插件 “{name}” 未安装。{availableLabel}: {available}",
        "instance.primaryAction": "主操作",
        "instance.ref.notExecuted": "未执行",
        "instance.ref.notFound": "未找到",
        "instance.ref.pathInvalid": "路径不存在",
        "instance.section.executionInfo": "执行信息",
        "instance.section.useConfig": "Use 配置",
        "instance.status.error": "失败",
        "instance.status.idle": "空闲",
        "instance.status.running": "运行中",
        "instance.status.success": "完成",
        "instance.templateNotExecutable": "模板单元不直接执行",
        "definition.contentInstance": "内容实例",
        "definition.dragMoveConfig": "拖动移动配置窗",
        "definition.moving": "移动中",
        "definition.noConfig": "此内容实例暂无可配置项",
        "definition.noOutputRun": "尚无输出 — 点击运行执行",
        "definition.notInstalled": "未安装",
        "definition.resizeConfig": "调整配置窗口大小",
        "definition.template": "模板",
        "definition.templateInstance": "模板实例",
        "definition.typeTitle": "类型: {type}",
        "template.defaultLabel": "默认: {value}",
        "template.inputFallback": "模板输入",
        "template.missingRequired": "必填参数未填写",
        "template.missingRequiredCount": "{count} 必填未填",
        "template.params": "模板参数",
        "template.unfilledCount": "{count} 未填",
        "template.valuePlaceholder": "{name} 的值…",
        "templateInputs.add": "新增",
        "templateInputs.closeEditor": "关闭 inputs 编辑器",
        "templateInputs.commaSeparated": "逗号分隔",
        "templateInputs.defaultValue": "默认值",
        "templateInputs.description": "说明",
        "templateInputs.displayName": "显示名",
        "templateInputs.dragMove": "拖动移动配置窗",
        "templateInputs.enum": "枚举",
        "templateInputs.jsonOrReference": "JSON 或引用",
        "templateInputs.name": "名称",
        "templateInputs.noDefaultValue": "无默认值",
        "templateInputs.noneDeclared": "还没有声明 input",
        "templateInputs.syncUndeclared": "{count} 个已使用 input 尚未声明，点击补齐",
        "templateInputs.type": "类型",
        "templateInputs.unnamedInput": "未命名 input",
        "editor.bookmark.addAtLine": "在第 {line} 行添加书签",
        "editor.bookmark.addWithLabel": "添加书签并设置标签...",
        "editor.bookmark.delete": "删除书签",
        "editor.bookmark.labelPrompt": "书签标签",
        "editor.bookmark.rename": "重命名书签...",
        "editor.codeAction.preferred": "首选",
        "editor.circularFailedHint": "请检查您的 Markdown 文件，确保插件之间没有相互引用。",
        "editor.circularFailedTitle": "执行失败！",
        "editor.renameTitle": "重命名 {id}",
        "editor.snapshot.error": "快照操作失败: {message}",
        "editor.snapshot.failed": "快照整个文件失败",
        "editor.snapshot.inProgress": "快照整个文件中...",
        "editor.snapshot.succeeded": "快照整个文件成功",
        "smartIntake.action.apply": "应用",
        "smartIntake.error.assetItemNotFound": "Smart Intake 没有找到资源项",
        "smartIntake.error.definitionNotFound": "未找到 definition: {id}",
        "smartIntake.error.filePayloadUnavailable": "Smart Intake 文件内容不可用",
        "smartIntake.error.saveAssetFailed": "保存 {name} 失败",
        "smartIntake.error.saveBeforeImport": "导入文件前需要先保存文档",
        "smartIntake.error.stageAssetFailed": "暂存 {name} 失败",
        "smartIntake.offer.insertAssets": "作为 Markdown 资源插入",
        "smartIntake.offer.insertAssets.description": "保存文件到文档 assets 并插入 Markdown 引用。",
        "smartIntake.offer.insertMarkdown": "作为 Markdown 插入",
        "smartIntake.offer.insertMarkdown.description": "在光标位置插入规范化后的 Markdown。",
        "smartIntake.offer.insertTable": "作为 Markdown 表格插入",
        "smartIntake.source.builtin": "内置",
        "smartIntake.status.applied": "Smart Intake 已应用",
        "smartIntake.status.failed": "Smart Intake 失败: {message}",
        "smartIntake.status.inlineImageFallback": "已以内联图片插入。保存文档后，后续文件会导入到 assets。",
        "smartIntake.status.saveBeforeImport": "导入文件前需要先保存文档。",
        "smartIntake.title": "Smart Intake",
        "doctor.assetsEscapesDir": "assets 引用路径不应跳出文档资源目录: {target}",
        "doctor.buffer": "缓冲区",
        "doctor.dependencyGraph": "依赖图",
        "doctor.close": "关闭 Doctor",
        "doctor.closeDependencyDetail": "关闭依赖详情",
        "doctor.closeTimelineDetail": "关闭资源时间线详情",
        "doctor.dependencyGraphTruncated.detail": "最多分析 {documents} 个导入文档、{nodes} 个资源节点。",
        "doctor.dependencyGraphTruncated.title": "依赖图较大，部分节点已截断",
        "doctor.errorCount": "{count} 错误",
        "doctor.hiddenCount": "隐藏 {count}",
        "doctor.largeDocument.detail": "大文档会增加解析、预览和会话同步成本。",
        "doctor.largeDocument.title": "文档文件偏大: {size}",
        "doctor.largeResource": "资源文件偏大: {name} ({size})",
        "doctor.missingAsset": "assets 引用的文件不存在: {target}",
        "doctor.missingDocumentPath": "缺少文档路径",
        "doctor.missingImport": "import 源文件不存在: {source}",
        "doctor.missingRef": "$ref 目标未在当前文档中找到: {id}",
        "doctor.missingRender": "render 目标未在当前文档中找到: {id}",
        "doctor.missingUse": "use 源目标未在当前文档中找到: {source}",
        "doctor.noDirectRelations": "无直接关系",
        "doctor.noIssues": "未发现明确问题",
        "doctor.noResourceTimeline": "暂无资源时间线",
        "doctor.noDependencies": "暂无依赖关系",
        "doctor.normal": "正常",
        "doctor.openDocument": "打开文档",
        "doctor.outputError": "{kind} \"{id}\" 输出错误",
        "doctor.problemCount": "问题 {count}",
        "doctor.refresh": "刷新",
        "doctor.resourceScanTruncated.detail": "只扫描了前 {count} 个条目。",
        "doctor.resourceScanTruncated.title": "{label} 文件较多，扫描已截断",
        "doctor.resourcesSize": "资源 {size}",
        "doctor.resourcesNone": "无资源包",
        "doctor.scanning": "扫描中…",
        "doctor.severity.error": "错误",
        "doctor.severity.info": "提示",
        "doctor.severity.warning": "警告",
        "doctor.showDetails": "查看详情",
        "doctor.toggleCollapse": "收起子项",
        "doctor.toggleExpand": "展开子项",
        "doctor.warningCount": "{count} 警告",
        "doctor.documentSummary": "文档 {size} / {lines} 行",
        "doctor.childCount": "{count} 子项",
        "doctor.inspector": "Doctor 检查器",
        "doctor.issues": "问题",
        "doctor.resourceTimeline": "资源时间线",
        "doctor.title": "Doctor",
        "documentRenderer.noContent": "暂无内容",
        "installedPlugins.empty": "暂无已安装插件",
        "installedPlugins.noMatching": "没有匹配的插件",
        "installedPlugins.searchPlaceholder": "搜索插件...",
        "installedPlugins.title": "已安装插件",
        "sidebar.close": "关闭侧栏",
        "sidebar.clickConfigButton": "在编辑器里点配置按钮",
        "sidebar.configure": "配置",
        "sidebar.configureUnit": "配置 {id}",
        "sidebar.cancelSelection": "取消选择",
        "sidebar.createdLocalOverride": "已创建本地覆盖: {id}",
        "sidebar.createLocalUseOverride": "在当前文档创建本地 use 覆盖",
        "sidebar.discardChanges": "放弃修改",
        "sidebar.importedFrom": "导入自",
        "sidebar.localOverride": "本地覆盖",
        "sidebar.pinnedUnit.dock": "停靠面板",
        "sidebar.pinnedUnit.float": "浮动面板",
        "sidebar.pinnedUnit.loading": "正在加载固定单元...",
        "sidebar.pinnedUnit.openSource": "打开源文档",
        "sidebar.pinnedUnit.remove": "从侧栏移除",
        "sidebar.pinnedUnit.unavailable": "固定单元不可用",
        "sidebar.requiresImportEditTarget": "导入单元的配置修改需要先选择源文件或本地覆盖",
        "sidebar.resize": "调整侧栏宽度",
        "sidebar.selectInstance": "选择一个实例",
        "sidebar.sourceFile": "源文件",
        "sidebar.title": "侧栏",
        "sidebar.unpin": "取消固定",
        "sidebar.unpinUnit": "取消固定 {id}",
        "sidebar.writeBackFailed": "写回源文件失败: {message}",
        "sidebar.writeBackSource": "写回导入源文件",
        "sidebar.wroteBackSource": "已写回源文件: {id}",
        "connector.action.cancel": "取消",
        "connector.action.connect": "连接",
        "connector.action.disconnect": "断开连接",
        "connector.action.refreshStatus": "刷新连接状态",
        "connector.action.probe": "检测 Engine",
        "connector.detected": "已检测到 Engine",
        "connector.disconnected": "已断开",
        "connector.gatewayHelp": "运行 {command} 启动 Gateway，默认端口 3721",
        "connector.localHelp": "运行 {command} 启动 Engine，默认端口 3721",
        "connector.mode.builtin": "内置",
        "connector.mode.builtinConnected": "内置 Engine",
        "connector.mode.cloud": "云端",
        "connector.mode.cloudConnected": "云端 Engine",
        "connector.mode.cloudHelp": "连接到云端 Engine 服务。",
        "connector.mode.devConnected": "开发模式",
        "connector.mode.devHelp": "Engine 从工作区自动启动，无需额外配置。",
        "connector.mode.gatewayConnected": "Gateway 连接",
        "connector.mode.local": "本地",
        "connector.mode.localConnected": "本地 Engine",
        "connector.mode.none": "断开",
        "connector.notConnected": "未连接",
        "connector.notReady": "Engine 未就绪",
        "connector.status.connecting": "正在连接...",
        "connector.status.ready": "就绪",
        "connector.status.starting": "启动中",
        "connector.title": "Engine 连接",
        "connector.editor.builtin.dir": "Engine 目录覆盖",
        "connector.editor.builtin.dirHelp": "默认使用应用内置 Engine；也可选择包含 {engine}、{plugins}、{sidecars} 的 Magic MD CLI 目录。",
        "connector.editor.builtin.source": "Engine 运行时",
        "connector.editor.builtin.bundled": "应用内置（默认）",
        "connector.editor.builtin.custom": "自选目录",
        "connector.editor.builtin.customDirRequired": "请先选择自定义 Engine 运行时目录再连接。",
        "connector.editor.builtin.sourceReconnectHint": "运行时变更将在下次连接内置 Engine 时生效。",
        "connector.editor.builtin.pickDir": "选择目录",
        "connector.editor.builtin.dialogTitle": "选择 Engine 目录（CLI 安装目录）",
        "connector.editor.builtin.checkExisting": "检查现有 Engine...",
        "connector.editor.builtin.missingDir": "无法解析应用内置 Engine",
        "connector.editor.builtin.notReady": "Engine 已启动但尚未就绪",
        "connector.editor.builtin.startFailed": "Engine 启动失败",
        "connector.editor.builtin.startingFromDir": "正在从 {dir} 启动 Engine...",
        "connector.editor.builtin.startTimeout": "Engine 启动超时（30s），请检查目录路径是否正确",
        "connector.editor.builtin.stoppingExisting": "停止现有 Engine（开发模式）...",
        "connector.editor.builtin.stopTimeout": "停止超时",
        "connector.editor.dev.restarting": "正在重启开发 Engine...",
        "connector.editor.dev.timeout": "开发模式 Engine 启动超时（15s）",
        "connector.editor.dev.wait": "等待开发 Engine 启动...",
        "connector.editor.dev.waitWithAttempt": "等待开发 Engine 启动... ({current}/{total})",
        "connector.editor.disconnectedHint": "选择「内置」即可默认使用应用打包的运行时，也可自选运行时目录或通过 Gateway 连接。",
        "connector.editor.gateway.title": "Web 访问（内网）",
        "connector.editor.gateway.lanHelp": "将当前同一个 Engine 暴露到全部内网网卡（0.0.0.0），暂不启用身份认证。",
        "connector.editor.gateway.unsupported": "当前 Engine 运行时不支持内置 Web 访问。",
        "connector.editor.gateway.copied": "已复制内网 Gateway 地址。",
        "connector.editor.gateway.openWeb": "打开 Web",
        "connector.editor.gateway.copyLanAddress": "复制内网地址",
        "connector.editor.gateway.stop": "停止 Web 访问",
        "connector.editor.gateway.start": "启动 Web 访问",
        "connector.editor.gateway.starting": "正在启动...",
        "connector.web.disconnectedHint": "运行 {command} 启动本地 Engine，或连接云端 Engine。",
        "continuation.checkReference": "请检查引用 ID 是否正确。",
        "continuation.depthDetail": "当前深度 {depth}，最大允许 {max}。",
        "continuation.depthLimit": "嵌套深度超限",
        "continuation.missingTarget": "{kind} \"{id}\" 未找到",
        "continuation.recursion": "循环挂载",
        "engine.mcp.clientsConnected": "{count} 个客户端已连接",
        "engine.refresh": "刷新",
        "engine.extensions.empty": "尚未安装扩展",
        "engine.sections.extensions": "扩展",
        "engine.sections.mcpServer": "MCP Server",
        "engine.sections.plugins": "插件",
        "engine.sections.sessions": "会话",
        "engine.sections.sidecars": "Sidecars",
        "engine.sessions.close": "关闭会话",
        "engine.sessions.closeAll": "关闭所有会话",
        "engine.sessions.empty": "没有活动会话",
        "engine.sessions.openFile": "打开文件",
        "engine.status.connected": "已连接",
        "engine.status.notRunning": "未运行",
        "engine.status.offline": "离线",
        "engine.status.online": "在线",
        "engine.status.starting": "启动中",
        "engine.status.startingShort": "启动中",
        "engine.plugins.actionCount": "{count} 个动作",
        "extensionDetail.activationEvents": "激活事件",
        "extensionDetail.backends": "后端绑定",
        "extensionDetail.contributions": "贡献能力",
        "extensionDetail.contributions.commands": "命令",
        "extensionDetail.contributions.contextMenus": "右键菜单",
        "extensionDetail.contributions.exports": "导出接口",
        "extensionDetail.contributions.runtimeEvents": "运行时事件",
        "extensionDetail.contributions.runtimeMethods": "运行时方法",
        "extensionDetail.contributions.settings": "设置入口",
        "extensionDetail.contributions.statusBar": "底部栏",
        "extensionDetail.contributions.unitActions": "Unit 动作",
        "extensionDetail.detailTitle": "扩展详情",
        "extensionDetail.features": "功能",
        "extensionDetail.homepage": "主页",
        "extensionDetail.manifest": "Manifest",
        "extensionDetail.notFound": "未找到扩展「{id}」",
        "extensionDetail.openPanel": "打开面板",
        "extensionDetail.overview": "概览",
        "extensionDetail.permissions": "权限",
        "extensionDetail.runtime": "运行时",
        "extensionDetail.runtime.status": "状态",
        "extensionDetail.runtime.type": "运行时类型",
        "extensionDetail.settings": "设置",
        "extensionDetail.settings.customPanel": "自定义面板",
        "extensionDetail.settings.fields": "Schema 字段",
        "extensionDetail.sidebarPanels": "侧栏面板",
        "extensionDetail.source.cssUrl": "CSS URL",
        "extensionDetail.source.invokeUrl": "Invoke URL",
        "extensionDetail.source.localPath": "本地路径",
        "extensionDetail.source.manifestPath": "Manifest 路径",
        "extensionDetail.source.manifestUrl": "Manifest URL",
        "extensionDetail.source.type": "类型",
        "extensionDetail.source.uiBundlePath": "UI Bundle 路径",
        "extensionDetail.source.uiBundleUrl": "UI Bundle URL",
        "extensionDetail.source.version": "版本",
        "extensionDetail.sourceInfo": "来源信息",
        "extensionDetail.status.active": "已激活",
        "extensionDetail.status.inactive": "未激活",
        "extensionPanel.cloudSource": "云端扩展",
        "extensionPanel.filter.all": "全部扩展",
        "extensionPanel.filter.cloud": "云端扩展",
        "extensionPanel.filter.local": "本地扩展",
        "extensionPanel.hasSidebarPanel": "包含侧栏面板",
        "extensionPanel.loadingWindow": "正在加载扩展面板...",
        "extensionPanel.missingWindowPanel": "这个窗口里没有加载到该扩展面板。",
        "extensionPanel.noMatching": "没有匹配的扩展",
        "extensionPanel.searchPlaceholder": "搜索扩展",
        "explorer.assets.copyMarkdown": "复制 Markdown 链接",
        "explorer.assets.copyRef": "复制 Assets 引用",
        "explorer.assets.copyRefPrefix": "复制 Assets 引用前缀",
        "explorer.assets.imported": "已导入 assets 文件: {name}",
        "explorer.assets.importFailed": "导入 assets 文件失败: {message}",
        "explorer.assets.importFile": "导入文件到 Assets...",
        "explorer.assets.createFileFailed": "创建 assets 文件失败: {message}",
        "explorer.assets.createFolderFailed": "创建 assets 文件夹失败: {message}",
        "explorer.assets.fileCreated": "已创建 assets 文件: {name}",
        "explorer.assets.folderCreated": "已创建 assets 文件夹: {name}",
        "explorer.assets.invalidFileName": "文件名无效",
        "explorer.assets.invalidFolderName": "文件夹名无效",
        "explorer.assets.newFile": "新建 Assets 文件",
        "explorer.assets.newFolder": "新建 Assets 文件夹",
        "explorer.assets.paste": "粘贴到 Assets",
        "explorer.bookmarks.delete": "删除书签",
        "explorer.bookmarks.line": "行 {line}",
        "explorer.bookmarks.lineTitle": "第 {line} 行",
        "explorer.bookmarks.renameLabel": "重命名标签",
        "explorer.closeFailed": "关闭失败: {message}",
        "explorer.configs.confirmDeleteAll": "删除该文档的全部文件化配置? 此操作不会删除源 Markdown 文件。",
        "explorer.configs.confirmDeleteEditor": "删除「{instanceId}」的 editor 文件化配置? 此操作不会删除源 Markdown 文件。",
        "explorer.configs.confirmDeleteFile": "删除「{name}」? 此操作不会修改源 Markdown 中的插件配置。",
        "explorer.configs.confirmDeleteInstance": "删除「{instanceId}」的文件化配置? 只会删除该实例目录，不会删除其它 configs。",
        "explorer.configs.confirmDeleteRender": "删除「{instanceId}」的 render 临时配置? 此操作不会删除源 Markdown 文件。",
        "explorer.configs.deleteAll": "删除全部 Configs",
        "explorer.configs.deleteEditor": "删除 Editor 配置目录",
        "explorer.configs.deleteFailed": "删除 Configs 失败: {message}",
        "explorer.configs.deleteFile": "删除 Configs 文件",
        "explorer.configs.deleteInstance": "删除「{instanceId}」配置目录",
        "explorer.configs.deleteRender": "删除 Render 配置目录",
        "explorer.configs.deleted": "Configs 文件已删除",
        "explorer.createFailed": "创建失败: {message}",
        "explorer.deleteFailed": "删除失败: {message}",
        "explorer.deleted": "已删除: {name}",
        "explorer.emptyFolder": "空文件夹",
        "explorer.selection.summary": "已选择 {count} 项 · 拖动任一选中项可一起移动（⌘/Ctrl 点选，Shift 连选）",
        "explorer.fileExists": "文件已存在: {name}",
        "explorer.files": "文件",
        "explorer.folderExists": "文件夹已存在: {name}",
        "explorer.history.createFullSnapshot": "创建快照（整个文件）",
        "explorer.history.createSnapshot": "创建快照",
        "explorer.history.deleteSnapshot": "删除快照",
        "explorer.history.deletingSnapshot": "删除中...",
        "explorer.history.restoreFull": "完整恢复...",
        "explorer.history.snapshotCreated": "快照整个文件成功",
        "explorer.history.snapshotDeleted": "快照已删除",
        "explorer.history.snapshotDeleteFailed": "快照删除失败",
        "explorer.history.snapshotFailed": "快照整个文件失败",
        "explorer.history.noSnapshots": "暂无快照",
        "explorer.history.snapshots": "快照",
        "explorer.history.snapshotTaking": "快照整个文件中...",
        "explorer.history.wholeFile": "整个文件",
        "explorer.moreActionsHint": "右键查看更多操作",
        "explorer.newFile": "新建文件",
        "explorer.newFolder": "新建文件夹",
        "explorer.noFolderOpen": "未打开文件夹",
        "explorer.openAnotherFolder": "打开其他文件夹",
        "explorer.operationFailed": "操作失败: {message}",
        "explorer.outputs.confirmDelete": "删除「{name}」输出产物目录? 此操作不会删除源 Markdown 文件。",
        "explorer.outputs.delete": "删除 Outputs 产物",
        "explorer.outputs.deleted": "Outputs 产物已删除",
        "explorer.outputs.deleteFailed": "删除 Outputs 产物失败: {message}",
        "explorer.preview.openInBrowser": "在浏览器中预览",
        "explorer.preview.running": "预览中",
        "explorer.preview.serverReady": "预览服务器已启动",
        "explorer.preview.starting": "启动中",
        "explorer.preview.switchServerHere": "切换预览服务器到此处",
        "explorer.publish.cancelled": "已取消",
        "explorer.publish.completed": "已发布",
        "explorer.publish.confirmDeleteFolderOutput": "删除「{name}」发布产物目录? 此操作不会删除源文件夹。",
        "explorer.publish.confirmDeleteDocumentOutput": "删除「{name}」发布产物目录? 此操作不会删除源 Markdown 文件。",
        "explorer.publish.deleteOutput": "删除发布产物",
        "explorer.publish.failed": "发布失败",
        "explorer.publish.outputDeleted": "发布产物已删除",
        "explorer.publish.outputDeleteFailed": "删除发布产物失败: {message}",
        "explorer.publish.revealOutput": "在文件夹中显示输出",
        "explorer.publish.running": "发布中",
        "explorer.publish.runningPages": "发布中 {processed}/{total}",
        "explorer.publish.runningPercent": "发布中 {percent}%",
        "explorer.renameFailed": "重命名失败: {message}",
        "explorer.refreshFailed": "刷新失败: {message}",
        "explorer.refreshed": "已刷新: {name}",
        "explorer.revealInFolder": "在文件夹中显示",
        "explorer.saveFailed": "保存失败: {message}",
        "explorer.starred": "已收藏",
        "explorer.trace.copyJson": "复制 Trace JSON",
        "explorer.trace.delete": "删除 Trace",
        "explorer.trace.deleted": "Trace 已删除: {name}",
        "explorer.trace.deleteConfirm": "删除 Trace「{name}」?",
        "explorer.trace.invalidFile": "Trace 文件无效: {traceId}",
        "explorer.trace.loadFailed": "Trace 加载失败: {message}",
        "explorer.trace.notFound": "未找到 Trace: {traceId}",
        "explorer.trace.save": "保存 Trace",
        "explorer.trace.saved": "Trace 已保存: {name}",
        "explorer.trace.saveFailed": "Trace 保存失败: {message}",
        "explorer.trace.showInTrace": "在 Trace 中显示",
        "explorer.workspace.addFolder": "添加文件夹到工作区",
        "explorer.workspace.addFolderFailed": "添加文件夹失败",
        "explorer.workspace.close": "关闭工作区",
        "explorer.workspace.closed": "工作区已关闭",
        "explorer.workspace.folderAdded": "文件夹已添加到工作区",
        "explorer.workspace.folderRemoved": "文件夹已从工作区移除",
        "explorer.workspace.opened": "工作区已打开",
        "explorer.workspace.openFile": "打开工作区文件",
        "explorer.workspace.removeFolder": "从工作区移除",
        "explorer.workspace.save": "保存工作区",
        "explorer.workspace.saved": "工作区已保存",
        "explorer.workspace.title": "工作区",
        "file.openFolder": "打开文件夹",
        "history.delete.deleted": "快照已删除",
        "history.delete.failed": "快照删除失败",
        "history.delete.failedWithMessage": "快照删除失败: {message}",
        "history.delete.inProgress": "删除快照中...",
        "history.noDiff": "无差异",
        "history.relative.daysAgo": "{count}天前",
        "history.relative.hoursAgo": "{count}小时前",
        "history.relative.minutesAgo": "{count}分钟前",
        "history.relative.secondsAgo": "{count}秒前",
        "history.restore.action": "恢复",
        "history.restore.failed": "恢复失败",
        "history.restore.inProgress": "恢复快照中...",
        "history.restore.restoredTo": "已恢复到 {time}",
        "history.restore.restoring": "恢复中...",
        "history.restore.snapshotFailed": "快照恢复失败",
        "history.restore.snapshotFailedWithMessage": "快照恢复失败: {message}",
        "history.restore.snapshotRestored": "快照已恢复",
        "history.snapshot": "快照",
        "history.snapshotWithTime": "快照 - {time}",
        "history.tab.content": "内容",
        "history.tab.diff": "差异",
        "history.undo.action": "撤销",
        "history.undo.failedWithMessage": "撤销失败: {message}",
        "history.undo.inProgress": "撤销恢复中...",
        "history.undo.success": "撤销恢复成功",
        "menu.addAssetsPackage": "添加资源包",
        "menu.addToFavorites": "添加到收藏",
        "menu.closeAll": "关闭全部",
        "menu.closeOthers": "关闭其他",
        "menu.closeToRight": "关闭右侧",
        "menu.copyFailed": "复制失败",
        "menu.copyFileName": "复制文件名",
        "menu.copyPath": "复制路径",
        "menu.copyRelativePath": "复制相对路径",
        "menu.copiedFileName": "已复制文件名",
        "menu.copiedRelativePath": "已复制相对路径",
        "menu.createAssetsPackageFailed": "创建资源包失败: {message}",
        "menu.externalOpenFailed": "{label} 失败: {message}",
        "menu.externalOpenUnsupported": "当前平台不支持外部打开",
        "menu.locateInExplorer": "定位到 Explorer",
        "menu.openFile": "打开文件",
        "menu.openToSide": "在侧边打开",
        "menu.openWith": "打开方式",
        "menu.previewPublish": "预览发布",
        "menu.publishDocument": "发布文档…",
        "menu.publishFolder": "发布文件夹…",
        "menu.removeFromFavorites": "从收藏移除",
        "menu.switchToFile": "切换到文件",
        "menu.assetsPackageReady": "资源包已准备好",
        "openFiles.backgroundRunning": "后台运行中",
        "openFiles.circularImport": "循环导入：{path}",
        "openFiles.titleWithCount": "打开的文件 ({count})",
        "recentFiles.titleWithCount": "最近打开 ({count})",
        "search.cancel": "取消搜索",
        "search.caseSensitive": "区分大小写",
        "search.empty": "输入关键词开始搜索",
        "search.excludePlaceholder": "排除 glob",
        "search.fileFilter": "文件过滤",
        "search.includePlaceholder": "包含 glob",
        "search.placeholder": "搜索",
        "search.regex": "正则表达式",
        "search.scope.session": "当前会话",
        "search.scope.workspace": "工作区",
        "search.status.results": "{matches} 个匹配，{files} 个文件",
        "search.status.truncated": "结果已截断",
        "search.wholeWord": "全词匹配",
        "settings.appearance.colorTheme.description": "当前项目默认激活的 Color Theme，可在个人或项目层覆盖。",
        "settings.appearance.colorTheme.title": "颜色主题",
        "settings.appearance.fileIconTheme.description": "当前项目默认激活的 File Icon Theme，可在个人或项目层覆盖。",
        "settings.appearance.fileIconTheme.title": "文件图标主题",
        "settings.appearance.productIconTheme.description": "当前项目默认激活的 Product Icon Theme，可在个人或项目层覆盖。",
        "settings.appearance.productIconTheme.title": "产品图标主题",
        "settings.apply.applying": "应用中...",
        "settings.apply.success": "已触发立即应用。",
        "settings.apply.unavailable": "当前无法立即应用这项配置。",
        "settings.autoSave.description": "编辑文档时自动保存到当前文件。",
        "settings.autoSave.title": "自动保存",
        "settings.boolean.disabled": "已关闭",
        "settings.boolean.enabled": "已启用",
        "settings.boolean.off": "关闭",
        "settings.boolean.on": "开启",
        "settings.boolean.stopped": "已停用",
        "settings.cancel": "取消",
        "settings.clear": "清除",
        "settings.clearTarget": "清除 {target}",
        "settings.close": "关闭设置",
        "settings.codeMirror.hoverDetail.description": "控制 CodeMirror 语法 hover 是否显示详细信息，可按项目覆盖。",
        "settings.codeMirror.hoverDetail.title": "悬浮信息详情",
        "settings.codeMirror.widgetMode.description": "在结构化 widget 展示和原始语法文本之间切换，可按项目覆盖。",
        "settings.codeMirror.widgetMode.title": "语法展示模式",
        "settings.configItemCount": "{count} 项配置",
        "settings.defaultPreviewWidth.description": "新 pane 或未显式设置时使用的预览宽度。",
        "settings.defaultPreviewWidth.title": "默认预览宽度",
        "settings.defaultViewMode.description": "控制新打开编辑区或新 pane 默认显示编辑、分栏或预览。",
        "settings.defaultViewMode.title": "默认视图模式",
        "settings.engine.allowedOperationDirs.description": "限制 Engine 文件读写、浏览和工作区操作的目录根列表；空值使用安全默认根。",
        "settings.engine.allowedOperationDirs.title": "允许操作的目录",
        "settings.engine.allowedSidecars.description": "空值表示不限制；数组表示白名单。",
        "settings.engine.allowedSidecars.title": "允许的 Sidecar",
        "settings.engine.docsDir.description": "Engine 默认文档目录。",
        "settings.engine.docsDir.title": "文档目录",
        "settings.engine.logLevel.description": "Engine 输出诊断日志的最低等级；CLI 和环境变量显式覆盖仍然优先。",
        "settings.engine.logLevel.title": "Engine 日志等级",
        "settings.engine.mcp.defaultPort.description": "MCP HTTP Server 的默认监听端口。设置后优先使用该端口，端口被占用时自动回退到随机端口。仅在非 Gateway 模式下生效。",
        "settings.engine.mcp.defaultPort.title": "MCP 默认端口",
        "settings.engine.pluginDirs.description": "Engine 启动时扫描的插件目录列表。",
        "settings.engine.pluginDirs.title": "插件目录",
        "settings.engine.startupTimeoutMs.description": "用于宿主启动 Engine 的超时阈值（毫秒）。",
        "settings.engine.startupTimeoutMs.title": "启动超时",
        "settings.gateway.allowedOrigins.description": "Gateway CORS 允许访问的来源列表。",
        "settings.gateway.allowedOrigins.title": "允许的来源",
        "settings.gateway.host.description": "Gateway HTTP 服务绑定的主机地址。",
        "settings.gateway.host.title": "监听地址",
        "settings.gateway.logLevel.description": "Gateway 和 Engine Bridge 输出诊断日志的最低等级；CLI 和环境变量显式覆盖仍然优先。",
        "settings.gateway.logLevel.title": "Gateway 日志等级",
        "settings.gateway.port.description": "Gateway HTTP 服务监听端口。",
        "settings.gateway.port.title": "监听端口",
        "settings.gateway.token.description": "Gateway Bearer Token，敏感值默认仅脱敏展示。",
        "settings.gateway.token.title": "访问令牌",
        "settings.detailMode.form": "设置",
        "settings.detailMode.info": "信息",
        "settings.diagnostics.errors": "{count} 个错误",
        "settings.diagnostics.removeFromTarget": "从{target}配置移除",
        "settings.diagnostics.sidecarsFsAlwaysEnabled": "内置 fs Sidecar 始终启用，配置中的 sidecars.fs.enabled 会被忽略。",
        "settings.diagnostics.title": "配置诊断",
        "settings.diagnostics.warnings": "{count} 个警告",
        "settings.directory.add": "添加目录",
        "settings.directory.emptyHelp": "每行一个目录；清空后保存会得到空列表，使用“清除”可恢复默认安全根。",
        "settings.directory.lineHelp": "每行一个目录，支持直接粘贴多行路径。",
        "settings.directory.pick": "选择目录",
        "settings.dynamic.pluginDefaults.description": "在文档实例配置之前合并的默认参数；Remote Host 可覆盖 Workspace。",
        "settings.dynamic.pluginDefaults.title": "{displayName} 默认实例配置",
        "settings.dynamic.pluginEnabled.description": "控制插件 {displayName} 是否允许执行；Remote Host 可覆盖 Workspace。",
        "settings.dynamic.pluginEnabled.title": "{displayName} 已启用",
        "settings.dynamic.pluginSettings.description": "插件 {displayName} 的长期设置；Remote Host 可覆盖 Workspace。",
        "settings.dynamic.pluginSettings.title": "{displayName} 设置",
        "settings.engine.cloudExtensionSources.description": "每行一个 Cloud Extension 源；可以直接填写 Worker 根地址，运行时会自动读取 /magic-md/extension.json。新增源会在当前 Engine 会话中自动注册。",
        "settings.engine.cloudExtensionSources.title": "Cloud Extension 源",
        "settings.engine.cloudExtensionCredentials.description": "用于受保护 Cloud Extension descriptor、bundle 和 Worker 调用的 Bearer token。",
        "settings.engine.cloudExtensionCredentials.title": "Cloud Extension Token",
        "settings.engine.cloudPluginSources.description": "每行一个云端插件源；可以直接填写 Worker 根地址，运行时会自动读取 /magic-md/plugin.json。新增源会在当前 Engine 会话中自动注册。",
        "settings.engine.cloudPluginSources.title": "云端插件源",
        "settings.engine.cloudSidecarSources.description": "每行一个 Cloud Sidecar 源。Worker 受保护时先在 Cloud Sidecar Token 中填写 Bearer token；Worker 根地址会解析到 /magic-md/sidecar.json，并推导 /magic-md/sidecar/rpc 作为调用端点。",
        "settings.engine.cloudSidecarSources.title": "Cloud Sidecar 源",
        "settings.engine.cloudSidecarCredentials.description": "用于受保护 Cloud Sidecar manifest 拉取和 RPC 调用的 Bearer token。",
        "settings.engine.cloudSidecarCredentials.title": "Cloud Sidecar Token",
        "settings.engine.cloudPluginCredentials.description": "用于受保护云端插件 descriptor、bundle 和 Worker 调用的 Bearer token。",
        "settings.engine.cloudPluginCredentials.title": "云端插件 Token",
        "settings.dynamic.sidecarEnabled.description": "控制后续会话是否允许自动启动 Sidecar {displayName}。",
        "settings.dynamic.sidecarEnabled.fsDescription": "内置文件系统 Sidecar，始终启用，供工作区与文件对话框使用。",
        "settings.dynamic.sidecarEnabled.title": "{displayName} 已启用",
        "settings.dynamic.sidecarSettings.description": "Sidecar {sidecarId} 的结构化运行配置。",
        "settings.dynamic.sidecarSettings.title": "{displayName} 设置",
        "settings.dynamic.extensionEnabled.description": "控制扩展 {displayName} 是否在当前层启用。",
        "settings.dynamic.extensionEnabled.title": "{displayName} 已启用",
        "settings.dynamic.extensionSettings.description": "扩展 {extensionId} 的长期运行配置。",
        "settings.dynamic.extensionSettings.title": "{displayName} 设置",
        "settings.effect.immediate": "立即生效",
        "settings.effect.nextSession": "下次会话生效",
        "settings.effect.restart": "需要重启",
        "settings.effectAction.apply": "立即应用",
        "settings.effectAction.restartEngine": "立即重启 Engine",
        "settings.effectAction.restartSidecar": "立即重启 Sidecar",
        "settings.effectAction.updateSidecar": "立即更新 Sidecar 状态",
        "settings.effectNotice.nextSession": "修改会在新会话或新启动的实例中生效。",
        "settings.effectNotice.restart": "配置已写入，需重启对应宿主进程。",
        "settings.empty.loadingSnapshot": "正在加载设置快照",
        "settings.extensions.empty": "尚未安装扩展",
        "settings.extensions.noConfig": "此扩展没有暴露可配置项。",
        "settings.extensions.noSelection": "选择一个扩展进行配置。",
        "settings.empty.noMatches": "当前分类下没有匹配的设置项",
        "settings.empty.selectEntry": "从左侧选择一个条目查看详情",
        "settings.empty.selectSetting": "选择一个设置项查看详情",
        "settings.group.appearance": "外观",
        "settings.group.contentPresentation": "内容与发布表现",
        "settings.group.general": "通用",
        "settings.groupSummary.extension": "扩展长期设置",
        "settings.groupSummary.plugin": "插件长期设置",
        "settings.groupSummary.sidecar": "Sidecar 长期运行设置",
        "settings.info.effect": "生效",
        "settings.info.override": "覆盖",
        "settings.info.source": "来源",
        "settings.info.status": "状态",
        "settings.keepDraft": "保留草稿",
        "settings.layer.consumer.editor": "编辑器",
        "settings.layer.consumer.extension": "扩展",
        "settings.layer.consumer.pluginExecution": "插件执行",
        "settings.layer.consumer.workspaceSession": "项目会话",
        "settings.layer.contextTitle": "消费方 / 生效范围",
        "settings.layer.current": "当前",
        "settings.layer.default": "默认",
        "settings.layer.draft": "草稿",
        "settings.layer.final": "最终",
        "settings.layer.noConfigFile": "无配置文件",
        "settings.layer.noWritableFile": "当前层没有可写入文件",
        "settings.layer.scope.remoteHost": "当前宿主",
        "settings.layer.scope.user": "当前用户",
        "settings.layer.scope.workspace": "当前项目",
        "settings.list.extensions": "扩展列表",
        "settings.list.plugins": "插件列表",
        "settings.list.sidecars": "Sidecar 列表",
        "settings.locale.description": "控制 Editor 和 Web 的界面语言；auto 会跟随系统语言。",
        "settings.locale.title": "显示语言",
        "settings.noExtraConfig": "无额外配置",
        "settings.noLongTermConfig": "当前条目只有启用开关，没有额外长期配置。",
        "settings.override.remoteHost": "已被宿主层覆盖",
        "settings.override.workspace": "已被项目层覆盖",
        "settings.preview.contentProfile.description": "控制 Preview / Readonly 的共享内容表现配置。",
        "settings.preview.contentProfile.title": "内容表现 Profile",
        "settings.previewWidth.compact": "紧凑",
        "settings.previewWidth.fill": "填满",
        "settings.previewWidth.reading": "阅读",
        "settings.previewWidth.wide": "宽屏",
        "settings.previewWidth.work": "工作",
        "settings.publish.presentationProfile.description": "控制 Publish / Presentation 的共享内容表现配置。",
        "settings.publish.presentationProfile.title": "发布表现 Profile",
        "settings.readOnly.builtin": "内置",
        "settings.readOnly": "当前目标只读",
        "settings.readOnly.cliOverride": "已被 CLI 参数覆盖",
        "settings.readOnly.envOverride": "已被环境变量覆盖",
        "settings.reload": "重新加载设置",
        "settings.remove": "移除",
        "settings.save": "保存",
        "settings.search.namePlaceholder": "搜索名称",
        "settings.search.placeholder": "搜索设置",
        "settings.secretMasked": "敏感设置当前仅支持脱敏查看。",
        "settings.section.editor": "编辑器",
        "settings.section.plugin": "插件",
        "settings.section.runtime": "运行时",
        "settings.section.sidecar": "Sidecars",
        "settings.showInlineDiagnostics.description": "在编辑器内联显示 Engine 返回的诊断信息。",
        "settings.showInlineDiagnostics.title": "显示行内诊断",
        "settings.source.default": "默认",
        "settings.source.env": "环境变量",
        "settings.source.remoteHost": "宿主",
        "settings.source.user": "个人",
        "settings.source.workspace": "项目",
        "settings.stale.message": "外部配置已更新，当前草稿可能过期。",
        "settings.target.remoteHost": "宿主",
        "settings.target.user": "个人",
        "settings.target.workspace": "项目",
        "settings.theme.active": "当前生效",
        "settings.theme.currentContentProfile": "当前内容 Profile {value}",
        "settings.theme.currentEffective": "当前生效 {value}",
        "settings.theme.currentFileIconTheme": "当前文件图标 {value}",
        "settings.theme.currentPresentationProfile": "当前发布 Profile {value}",
        "settings.theme.currentProductIconTheme": "当前图标 {value}",
        "settings.theme.currentSelection": "当前选择 {value}",
        "settings.theme.effectiveKind": "生效类型：{kind}",
        "settings.theme.kind.dark": "深色",
        "settings.theme.kind.hcDark": "高对比深色",
        "settings.theme.kind.hcLight": "高对比浅色",
        "settings.theme.kind.light": "浅色",
        "settings.theme.preview.body": "正文",
        "settings.theme.preview.sample": "Aa 样例",
        "settings.theme.profileSample": "这是一段固定样文，用来感知字号、宽度、行高与段落节奏的变化。",
        "settings.theme.scope.content": "Content",
        "settings.theme.scope.presentation": "Presentation",
        "settings.title": "设置",
        "settings.value.defaultValue": "默认 {value}",
        "settings.value.emptyList": "空列表",
        "settings.value.emptyObject": "空对象",
        "settings.value.inheritDefault": "继承默认",
        "settings.value.items": "项",
        "settings.value.unset": "未设置",
        "settings.value.useDefault": "使用默认",
        "sidebar.engine": "Engine",
        "sidebar.engineConnector": "Engine 连接设置",
        "sidebar.explorer": "资源管理器",
        "sidebar.openFiles": "打开的文件",
        "sidebar.publish": "发布",
        "sidebar.search": "搜索",
        "sidebar.settings": "设置",
        "sidebar.toc": "大纲",
        "status.all": "全部",
        "status.error": "错误",
        "status.loading": "加载中",
        "status.pending": "等待中",
        "status.running": "运行中",
        "status.starting": "启动中",
        "status.stopped": "已停止",
        "status.stopping": "停止中",
        "status.success": "成功",
        "statusbar.activity.completed": "已完成",
        "statusbar.activity.execute": "执行",
        "statusbar.activity.failed": "失败",
        "statusbar.activity.read": "读取",
        "statusbar.activity.write": "写入",
        "statusbar.cursor": "行 {line}，列 {col}",
        "statusbar.definitions": "{count} 个定义",
        "statusbar.details.definitions": "定义",
        "statusbar.details.encoding": "编码",
        "statusbar.details.format": "格式",
        "statusbar.details.open": "显示状态详情",
        "statusbar.details.plugins": "插件",
        "statusbar.details.sessions": "会话",
        "statusbar.details.sidecars": "Sidecar",
        "statusbar.details.title": "状态详情",
        "statusbar.documentStats": "{lines} 行 · {words} 词",
        "statusbar.execution.errorAria": "{count} 个执行错误",
        "statusbar.execution.moreErrors": "另有 {count} 个错误",
        "statusbar.execution.viewLogs": "查看日志",
        "statusbar.logs.hide": "隐藏日志",
        "statusbar.logs.show": "显示日志",
        "statusbar.mcp.detailTitle": "MCP 详情",
        "statusbar.mcp.start": "启动 MCP Server",
        "statusbar.mcp.stop": "停止 MCP Server",
        "statusbar.mcp.suffix.error": " 错误",
        "statusbar.mcp.suffix.starting": " 启动中",
        "statusbar.mcp.suffix.stopping": " 停止中",
        "statusbar.plugins": "{count} 个插件",
        "statusbar.plugins.loading": "正在加载插件",
        "statusbar.plugins.loadingMore": "正在加载 {name} +{count}",
        "statusbar.plugins.loadingNamed": "正在加载 {name}",
        "statusbar.plugins.ready": "{count} 个插件就绪",
        "statusbar.ref.notExecuted": "{count} 个引用尚未执行",
        "statusbar.ref.notFound": "{count} 个引用未找到",
        "statusbar.sessions.label": "{count} 个会话",
        "statusbar.sessions.title": "{count} 个活动会话",
        "statusbar.sidecars.label": "{count} 个 Sidecar",
        "statusbar.sidecars.title": "{count} 个活动 Sidecar",
        "statusbar.source.externalEdit": "外部编辑",
        "statusbar.source.unknown": "未知来源",
        "statusbar.tools.addRender": "添加 render",
        "statusbar.tools.cancelExecution": "取消执行",
        "statusbar.tools.closeDocument": "关闭文档",
        "statusbar.tools.createContentBlock": "创建 content 块",
        "statusbar.tools.createDefinition": "创建定义",
        "statusbar.tools.createForBlock": "创建 for 块",
        "statusbar.tools.createImport": "创建 import",
        "statusbar.tools.createMeta": "创建 meta",
        "statusbar.tools.createUseBlock": "创建 use 块",
        "statusbar.tools.deleteContentBlock": "删除 content 块",
        "statusbar.tools.deleteDefinition": "删除定义",
        "statusbar.tools.deleteForBlock": "删除 for 块",
        "statusbar.tools.deleteImport": "删除 import",
        "statusbar.tools.deleteRender": "删除 render",
        "statusbar.tools.deleteUseBlock": "删除 use 块",
        "statusbar.tools.editContentBlock": "编辑 content 块",
        "statusbar.tools.editDefinition": "编辑定义",
        "statusbar.tools.editForBlock": "编辑 for 块",
        "statusbar.tools.editImport": "编辑 import",
        "statusbar.tools.editMeta": "编辑 meta",
        "statusbar.tools.editUseBlock": "编辑 use 块",
        "statusbar.tools.getDocumentContent": "获取文档内容",
        "statusbar.tools.getExecutionState": "获取执行状态",
        "statusbar.tools.getPluginSchema": "获取插件 Schema",
        "statusbar.tools.getPluginRuntimeInfo": "获取插件运行时信息",
        "statusbar.tools.insertText": "插入文本",
        "statusbar.tools.listDefinitions": "列出定义",
        "statusbar.tools.listDocuments": "列出文档",
        "statusbar.tools.listFiles": "列出文件",
        "statusbar.tools.listPlugins": "列出插件",
        "statusbar.tools.openDocument": "打开文档",
        "statusbar.tools.readOutput": "读取输出",
        "statusbar.tools.renameDefinition": "重命名定义",
        "statusbar.tools.replaceText": "替换文本",
        "statusbar.tools.startExecution": "开始执行",
        "statusbar.tools.validateDocument": "校验文档",
        "pluginDetail.action.openSettings": "打开设置",
        "pluginDetail.action.goBack": "返回",
        "pluginDetail.api.empty": "没有匹配的 API",
        "pluginDetail.api.filterPlaceholder": "筛选 API",
        "pluginDetail.api.noProperties": "未声明属性",
        "pluginDetail.api.noSelection": "选择一个 API",
        "pluginDetail.api.paramsSchema": "请求参数 Schema",
        "pluginDetail.api.rawSchema": "原始 Schema",
        "pluginDetail.api.resultSchema": "返回数据 Schema",
        "pluginDetail.backendBinding": "后端绑定",
        "pluginDetail.configParameters": "配置参数",
        "pluginDetail.detailTitle": "插件详情",
        "pluginDetail.documentInstances": "文档实例",
        "pluginDetail.documentEffect": "文档",
        "pluginDetail.effect.none": "无",
        "pluginDetail.effect.read": "读",
        "pluginDetail.effect.write": "写",
        "pluginDetail.error": "错误",
        "pluginDetail.externalEffect": "外部",
        "pluginDetail.hasOutput": "有输出",
        "pluginDetail.homepage": "主页",
        "pluginDetail.installed": "已安装",
        "pluginDetail.markdown": "Markdown",
        "pluginDetail.noOutput": "无输出",
        "pluginDetail.notFound": "未找到插件「{name}」",
        "pluginDetail.outputSchema": "输出 Schema",
        "pluginDetail.overview": "概览",
        "pluginDetail.primary": "主操作",
        "pluginDetail.dangerous": "危险操作",
        "pluginDetail.render.block": "块级",
        "pluginDetail.render.inline": "行内",
        "pluginDetail.renderModes": "渲染模式",
        "pluginDetail.runtimeApis": "运行时 API",
        "pluginDetail.section.actions": "操作",
        "pluginDetail.smartIntake": "Smart Intake",
        "pluginDetail.smartIntake.accepts": "支持内容",
        "pluginDetail.smartIntake.dynamicAccepts": "动态",
        "pluginDetail.smartIntake.kind.file": "文件",
        "pluginDetail.smartIntake.kind.folder": "文件夹",
        "pluginDetail.smartIntake.kind.har": "HAR",
        "pluginDetail.smartIntake.kind.html": "HTML",
        "pluginDetail.smartIntake.kind.json": "JSON",
        "pluginDetail.smartIntake.kind.magic-fragment": "Magic 片段",
        "pluginDetail.smartIntake.kind.table": "表格",
        "pluginDetail.smartIntake.kind.text": "文本",
        "pluginDetail.smartIntake.kind.url": "URL",
        "pluginDetail.smartIntake.provider.runtime": "Runtime",
        "pluginDetail.smartIntake.provider.ui": "UI",
        "pluginDetail.sourceInfo": "来源信息",
        "pluginDetail.staticBinding": "静态绑定",
        "pluginDetail.staticBindings": "静态绑定",
        "pluginDetail.timeoutSecs": "超时 {seconds}s",
        "pluginDetail.usageExamples": "使用示例",
        "pluginSource.cloudBundle": "云端包",
        "pluginSource.cloudBundle.tooltip": "从云端源下载后在本地执行",
        "pluginSource.cloudWorker": "云端 Worker",
        "pluginSource.cloudWorker.tooltip": "在 Cloudflare Worker 远程执行",
        "pluginSource.detail.apiUrl": "API 地址",
        "pluginSource.detail.bundleBaseUrl": "包基础地址",
        "pluginSource.detail.deployedVersion": "部署版本",
        "pluginSource.detail.healthUrl": "健康检查地址",
        "pluginSource.detail.host": "主机",
        "pluginSource.detail.invokeUrl": "调用地址",
        "pluginSource.detail.manifestUrl": "Manifest 地址",
        "pluginSource.detail.pluginAddress": "插件地址",
        "pluginSource.detail.provider": "服务商",
        "pluginSource.detail.publishUrl": "发布渲染地址",
        "pluginSource.detail.remoteUrl": "远程地址",
        "pluginSource.detail.smartIntakeBuildPlanUrl": "Smart Intake 构建计划地址",
        "pluginSource.detail.smartIntakeProposeUrl": "Smart Intake 建议地址",
        "pluginSource.detail.type": "类型",
        "pluginSource.filter.all": "全部",
        "pluginSource.local": "本地",
        "pluginSource.local.tooltip": "从本地插件文件加载",
        "pluginPanel.action.openDetail": "打开详情",
        "pluginPanel.action.run": "运行",
        "pluginPanel.action.runAll": "全部运行",
        "pluginPanel.action.runAllTitle": "按依赖顺序运行所有插件",
        "pluginPanel.action.runContent": "运行 content",
        "pluginPanel.action.runFor": "运行 for 循环",
        "pluginPanel.action.runImport": "运行 import",
        "pluginPanel.action.runUse": "运行 use",
        "pluginPanel.action.stop": "停止",
        "pluginPanel.action.stopFor": "停止 for 循环",
        "pluginPanel.action.stopRun": "停止运行",
        "pluginPanel.empty.addHint": "使用 {syntax} 添加",
        "pluginPanel.empty.noInstances": "没有插件实例",
        "pluginPanel.filterPlaceholder": "过滤实例...",
        "pluginPanel.instances": "实例",
        "pluginPanel.noMatches": "没有匹配「{query}」的实例",
        "pluginPanel.section.content": "Content",
        "pluginPanel.section.define": "Define",
        "pluginPanel.section.for": "For",
        "pluginPanel.section.import": "Import",
        "pluginPanel.section.use": "Use",
        "pluginPanel.status.done": "完成",
        "pluginPanel.status.running": "运行中",
        "pluginPanel.type.static": "static",
        "pluginPanel.type.template": "template",
        "publish.action.cancel": "取消",
        "publish.action.cancelPublish": "取消发布",
        "publish.action.copySiteUrl": "复制站点地址",
        "publish.action.republish": "重新发布",
        "publish.action.retry": "重试",
        "publish.action.saveConfig": "保存配置",
        "publish.action.start": "开始发布",
        "publish.action.startPreviewServer": "启动预览服务器",
        "publish.action.startSite": "发布站点",
        "publish.action.stopPreviewServer": "停止预览服务器",
        "publish.action.stopServer": "停止服务器",
        "publish.baseUrlHelp": "用于生成 sitemap（可选）",
        "publish.buildStrategy.full": "完整构建",
        "publish.buildStrategy.incrementalHash": "增量构建（内容哈希缓存）",
        "publish.chooseDocumentOutputDir": "选择单文档 publish 输出目录",
        "publish.chooseFolderOutputDir": "选择文件夹 publish 输出目录",
        "publish.commaSeparated": "（逗号分隔）",
        "publish.completed": "站点发布完成",
        "publish.contentSource.diskFile": "磁盘文件",
        "publish.contentSource.openBuffer": "当前编辑器内容",
        "publish.customDocumentOutDirWarning": "自定义输出目录不会把真实产物挂到当前文档的 publish package；package 内仍会保留配置、状态和报告文件。",
        "publish.defaultOutDirHelp": "留空时使用默认目录: {dir}",
        "publish.document": "发布文档",
        "publish.documentRunningHint": "当前文档已有发布任务在运行中。可在 publish package 的 publish.status.json 中查看实时状态。",
        "publish.error.outDirRequired": "输出目录不能为空。",
        "publish.error.startFailed": "发布启动失败，请检查 publish.status.json 或 Engine 状态。",
        "publish.failed": "站点发布失败",
        "publish.field.buildStrategy": "构建策略",
        "publish.field.contentSource": "内容来源",
        "publish.field.baseUrl": "Base URL",
        "publish.field.exclude": "排除模式",
        "publish.field.include": "包含模式",
        "publish.field.outputDir": "输出目录",
        "publish.field.siteTitle": "站点标题",
        "publish.field.themeSnapshot": "主题快照",
        "publish.field.workspacePath": "工作区路径",
        "publish.option.clean": "清理输出目录",
        "publish.option.incrementalHash": "增量构建（基于内容哈希缓存）",
        "publish.option.incremental": "增量构建（跳过未变更文档）",
        "publish.option.rerunAll": "重新执行所有 definitions",
        "publish.option.useOpenBuffer": "使用当前编辑器内容",
        "publish.option.useOpenBufferWithUnsaved": "使用当前编辑器内容（包含未保存修改）",
        "publish.folder": "发布文件夹",
        "publish.folderBadge": "文件夹",
        "publish.folderTitle.completed": "文件夹发布 - 完成",
        "publish.folderTitle.failed": "文件夹发布 - 失败",
        "publish.folderTitle.running": "文件夹发布 - 进行中",
        "publish.generatedAt": "生成时间: {generatedAt}",
        "publish.noOpenBuffer": "当前文件未在编辑器中打开，本次发布将直接读取磁盘内容。",
        "publish.notSet": "未设置",
        "publish.outputPath": "输出: {outputDir}",
        "publish.package": "发布包",
        "publish.pageList": "页面列表",
        "publish.pageProgress": "页面进度",
        "publish.placeholder.siteTitle": "我的站点",
        "publish.previewServer": "预览服务器",
        "publish.running": "站点发布中...",
        "publish.processingProgress": "处理进度: {processed}/{total} 页",
        "publish.serverRunning": "运行中",
        "publish.serverStarting": "正在启动服务器...",
        "publish.singleDocument": "单文档",
        "publish.stat.built": "构建",
        "publish.stat.cached": "缓存",
        "publish.stat.failed": "失败",
        "publish.stat.total": "总计",
        "publish.status.built": "构建",
        "publish.status.cached": "缓存",
        "publish.status.configSaved": "发布配置已保存",
        "publish.status.configSavedInPackage": "发布配置已保存，可在 publish package 中查看",
        "publish.status.failed": "发布失败: {message}",
        "publish.title": "站点发布",
        "publish.totalPages": "总计 {total} 页",
        "publish.unsavedChanges": "含未保存修改",
        "publish.untitledSite": "未命名站点",
        "publish.unknownError": "未知错误",
        "publish.warning.invalidConfig": "已有配置文件格式无效，已回退到默认配置。",
        "publish.warning.readConfigFailed": "读取配置失败: {message}",
        "engineDetail.description": "通过 stdio 使用 JSON-RPC 2.0，负责插件执行、Sidecar 进程和文档编排。",
        "engineDetail.activity.activeFilter": "当前",
        "engineDetail.activity.activeSession": "当前活动会话：{name}",
        "engineDetail.activity.all": "全部活动",
        "engineDetail.activity.empty": "没有匹配的会话。",
        "engineDetail.activity.emptyState": "打开文档或运行插件后，这里会显示会话和执行活动。",
        "engineDetail.activity.executionTotal": "执行总数",
        "engineDetail.activity.filterPlaceholder": "筛选会话...",
        "engineDetail.activity.index": "活动索引",
        "engineDetail.activity.noAction": "无操作名称",
        "engineDetail.activity.noActiveSession": "当前没有活动会话。",
        "engineDetail.activity.noExecutionDetail": "这条执行还没有输出、错误或进度详情。",
        "engineDetail.activity.noSessionSelected": "选择左侧会话后查看该会话的执行活动。",
        "engineDetail.activity.openSession": "查看会话",
        "engineDetail.activity.overview": "活动概览",
        "engineDetail.activity.progress": "进度",
        "engineDetail.activity.title": "会话执行活动",
        "engineDetail.activity.withActivity": "有活动",
        "engineDetail.executionActivity": "执行活动",
        "engineDetail.execution.cached": "已缓存",
        "engineDetail.execution.currently": "当前",
        "engineDetail.execution.empty": "暂无执行记录。运行插件后会在这里看到执行活动。",
        "engineDetail.execution.failed": "失败",
        "engineDetail.execution.idle": "空闲",
        "engineDetail.execution.output": "输出",
        "engineDetail.execution.runAllProgress": "全部运行中",
        "engineDetail.execution.started": "开始于",
        "engineDetail.execution.duration": "耗时",
        "engineDetail.execution.action": "操作",
        "engineDetail.execution.filterPlaceholder": "筛选执行...",
        "engineDetail.execution.noMatches": "没有匹配的执行记录。",
        "engineDetail.protocol.events": "Server -> Client 事件",
        "engineDetail.protocol.event": "事件",
        "engineDetail.protocol.dir": "方向",
        "engineDetail.protocol.framing": "帧格式",
        "engineDetail.protocol.methods": "RPC 方法",
        "engineDetail.protocol.method": "方法",
        "engineDetail.server": "Engine Server",
        "engineDetail.starting": "Engine Server 正在启动...",
        "engineDetail.notRunning": "Engine Server 未运行",
        "engineDetail.autoStartHint": "应用启动时会自动启动 Engine Server。",
        "previewWidth.adjust": "调整预览宽度",
        "previewWidth.adjustTitle": "调整预览宽度：{label}",
        "previewWidth.compact": "紧凑",
        "previewWidth.custom": "自定义",
        "previewWidth.customWithWidth": "自定义 {width}px",
        "previewWidth.fill": "填满",
        "previewWidth.reading": "阅读",
        "previewWidth.reset": "重置宽度",
        "previewWidth.wide": "宽屏",
        "previewWidth.work": "工作",
        "pane.close": "关闭面板",
        "pane.collapse": "收起面板",
        "pane.count": "{count} 面板",
        "pane.defaultTitle": "面板",
        "pane.dropHere": "放置到此面板",
        "pane.expand": "展开面板",
        "pane.expandGroup": "展开面板组",
        "pane.expandGroupWithTitle": "展开面板组 {title}",
        "pane.expandWithTitle": "展开面板 {title}",
        "pane.resizeEditorPreview": "调整编辑器与预览宽度",
        "pane.resizeHorizontal": "调整左右窗格宽度",
        "pane.resizeVertical": "调整上下窗格高度",
        "pane.splitDown": "向下创建面板",
        "pane.splitRight": "向右创建面板",
        "pane.unsavedChanges": "有未保存修改",
        "platform.applyUnsupported": "该配置不需要单独触发应用。",
        "platform.engineReconnected": "Engine 已重新连接，后续会话将使用新配置。",
        "platform.engineRestartFailed": "Engine 重启失败。",
        "platform.engineRestarted": "Engine 已重启。",
        "platform.restartUnsupported": "当前连接模式不支持从客户端直接重启宿主进程。",
        "platform.sidecarIdInvalid": "无法识别 Sidecar 标识。",
        "platform.cloudSidecarSettingsApplied": "{sidecarId} 设置已保存。Cloud Sidecar 不会启动本地进程。",
        "platform.sidecarRestarted": "{sidecarId} 已重启并应用新设置。",
        "platform.sidecarStarted": "{sidecarId} 已启动。",
        "platform.sidecarStopped": "{sidecarId} 已停止。",
        "platform.webRestartUnsupported": "当前 Web 模式不支持从这里直接重启远端 Engine/Gateway。",
        "definitionPanel.actions": "操作",
        "definitionPanel.config": "配置",
        "definitionPanel.discard": "放弃",
        "definitionPanel.output": "输出",
        "definitionPanel.outputDuration": "最近执行耗时 {duration}ms",
        "definitionPanel.saveConfigTitle": "保存配置到文档",
        "definitionPanel.switchToJson": "切换到 JSON 编辑",
        "definitionPanel.switchToVisual": "切换到可视编辑",
        "definitionPanel.unsavedConfig": "未保存的配置修改",
        "copy.bodyReference": "复制 Body 引用",
        "copy.config": "复制配置",
        "copy.contentBody": "复制内容正文",
        "copy.definitionSnippet": "复制定义片段",
        "copy.documentPath": "复制文档路径",
        "copy.id": "复制 ID",
        "copy.forSnippet": "复制循环片段",
        "copy.loopSource": "复制循环数据源",
        "copy.output": "复制输出",
        "copy.path": "复制路径",
        "copy.reference": "复制引用",
        "copy.failed": "复制失败",
        "copy.referenceHint": "复制引用；右键查看更多复制操作",
        "copy.renderStatement": "复制渲染语句",
        "render.action.debug": "调试",
        "render.action.rerun": "重新运行",
        "render.action.run": "运行",
        "render.component": "组件",
        "render.configureUse": "配置 use",
        "render.content.failedMessage": "Content 执行失败",
        "render.content.instance": "Content 实例",
        "render.content.notRunMessage": "尚未运行。点击运行后会在这里显示 Content 结果。",
        "render.content.parsing": "解析中",
        "render.content.parsingEllipsis": "解析中...",
        "render.content.parsingMessage": "Content 正在解析，完成后会在这里显示结果。",
        "render.content.scoped": "嵌套 Content",
        "render.deps.jumpTo": "跳转到 {id}",
        "render.deps.noPredecessors": "无前继节点",
        "render.deps.noSuccessors": "无后继节点",
        "render.deps.predecessors": "前继节点 · {id}",
        "render.deps.successors": "后继节点 · {id}",
        "render.deps.title": "前继 / 后继节点",
        "render.expandUnit": "展开 {id}",
        "render.fullscreen.adjustWidth": "调整全屏宽度",
        "render.fullscreen.adjustWidthTitle": "调整全屏宽度：{label}",
        "render.fullscreen.enter": "工作区全屏",
        "render.fullscreen.exit": "退出工作区全屏",
        "render.fullscreen.resizeLeft": "向左拖拽调整全屏宽度，双击重置",
        "render.fullscreen.resizeRight": "向右拖拽调整全屏宽度，双击重置",
        "render.fullscreen.resizeTitle": "拖拽调整宽度，双击重置",
        "render.importRunning": "import {namespace} 运行中…",
        "render.importDocument.imported": "已导入",
        "render.importDocument.label": "导入文档",
        "render.importDocument.refreshing": "刷新中",
        "render.inlineRef.contentNotFound": "未找到内容定义：{ref}",
        "render.inlineRef.notExecuted": "未执行：{ref}",
        "render.inlineRef.pathMissing": "路径不存在：{ref}",
        "render.inlineRef.unitNotFound": "未找到 unit：{ref}",
        "render.kind.definition": "定义",
        "render.kind.forLoop": "For 循环",
        "render.missingParams": "缺少: {params}",
        "render.params": "参数: {params}",
        "render.pinToSidebar": "添加到侧栏",
        "render.placeholder.externalOutput": "已有外部输出，滚动到可见区域后加载。",
        "render.placeholder.importNotRun": "尚未导入输出。点击运行后会刷新来源快照。",
        "render.placeholder.loadingOutput": "加载输出中...",
        "render.placeholder.loadingPlugin": "正在加载插件 UI...",
        "render.placeholder.notRun": "尚未运行。点击运行后会在这里显示组件结果。",
        "render.placeholder.noRenderer": "插件没有 Renderer，无法在 Preview 中展示组件结果。",
        "render.placeholder.outputLoadFailed": "输出加载失败：{error}",
        "render.placeholder.outputLoadFailedShort": "输出加载失败",
        "render.rerunImport": "重新运行 import {namespace}",
        "render.runImport": "运行 import {namespace}",
        "render.runUnit": "运行 {id}",
        "render.for.collapseAll": "收起全部",
        "render.for.collapseAllIterations": "收起所有迭代",
        "render.for.expandAll": "展开全部",
        "render.for.expandAllIterations": "展开所有迭代",
        "render.for.failedCount": "{count} 失败",
        "render.for.source": "数据源",
        "render.for.sourceTitle": "数据源：{source}",
        "render.status.failed": "运行失败",
        "render.status.importing": "导入中",
        "render.status.loadFailed": "加载失败",
        "render.status.notRun": "未运行",
        "render.status.notInstalled": "未安装",
        "render.status.notRenderable": "不可渲染",
        "render.status.pendingLoad": "待加载",
        "render.status.ran": "已运行",
        "render.status.rendered": "已渲染",
        "render.status.runningEllipsis": "运行中…",
        "render.template.configure": "配置模板",
        "render.template.message": "模板不会直接执行。通过 ::use 实例化后渲染。",
        "render.template.status": "{kind}模板",
        "render.templateUsage.message": "{location} 使用了模板参数，但未标记 template=\"true\"。",
        "render.templateUsage.missingTemplate": "缺少 template",
        "render.unpin": "从侧栏移除",
        "render.useIncomplete.message": "缺少必填模板参数：{missing}。请在 ::use[{id}] 的 with 中填写后再渲染。",
        "render.useIncomplete.status": "Use 实例未完成",
        "render.useTemplate.message": "这个 ::use 仍是模板别名，不会直接执行。通过另一个 ::use 实例化后渲染。",
        "render.useTemplate.status": "Use 模板",
        "preview.audio": "音频",
        "preview.emptyFile": "文件为空",
        "preview.imageLoadFailed": "图片加载失败",
        "preview.jsonParseFailed": "JSON 解析失败: {message}",
        "preview.noContent": "无内容",
        "preview.noDiff": "无差异",
        "preview.noFilePath": "未指定文件路径",
        "preview.openInDesktop": "请在桌面端 Editor 中打开",
        "preview.resizeLeft": "向左拖拽调整预览宽度，双击重置",
        "preview.resizeRight": "向右拖拽调整预览宽度，双击重置",
        "preview.snapshot.closePreview": "关闭预览",
        "preview.snapshot.content": "内容",
        "preview.snapshot.diff": "差异",
        "preview.snapshot.file": "文件",
        "preview.snapshot.next": "下一个快照",
        "preview.snapshot.previous": "上一个快照",
        "preview.snapshot.trigger.auto": "自动",
        "preview.snapshot.trigger.manual": "手动",
        "preview.html.title": "HTML 预览",
        "preview.svgRenderFailed": "SVG 渲染失败",
        "preview.svgSourceEmpty": "SVG 源为空",
        "preview.tablePreview": "表格预览",
        "preview.tableStats": "{rows} 行 · {columns} 列",
        "preview.tableTruncated": "仅显示前 {maxRows}",
        "preview.unsupportedImage": "此平台不支持本地图片预览",
        "preview.unsupportedMedia": "此平台不支持本地媒体预览",
        "preview.unsupportedPdf": "此平台不支持本地 PDF 预览",
        "preview.video": "视频",
        "log.advancedFilters": "高级过滤",
        "log.clearAll": "清空全部日志",
        "log.collapsePanel": "收起日志面板",
        "log.detail": "日志详情",
        "log.field.data": "数据",
        "log.field.definition": "定义",
        "log.field.level": "级别",
        "log.field.message": "消息",
        "log.field.plugin": "插件",
        "log.field.source": "来源",
        "log.field.stack": "堆栈",
        "log.field.time": "时间",
        "log.maximizeHeight": "撑满高度",
        "log.panelViews": "日志面板视图",
        "log.resizePanel": "调整底部面板高度",
        "log.restoreHeight": "恢复默认高度",
        "log.searchPlaceholder": "搜索日志...",
        "log.source.engine": "Engine",
        "log.source.mcp": "MCP",
        "log.source.parser": "Parser",
        "log.source.plugin": "插件",
        "log.source.extension": "扩展",
        "log.source.resolver": "Resolver",
        "log.source.sidecar": "Sidecar",
        "log.source.system": "系统",
        "log.source.transport": "Transport",
        "log.source.ui": "UI",
        "log.tab.debug": "调试",
        "log.tab.logs": "日志",
        "log.tab.timeline": "时间线",
        "log.tab.trace": "Trace",
        "log.tab.watches": "监控",
        "log.title": "日志",
        "log.toggleLevel": "切换 {level} 日志",
        "trace.clear": "清空",
        "trace.cloudWorker": "Cloud Worker",
        "trace.cloudSidecar": "Cloud Sidecar",
        "trace.closeDetails": "关闭详情",
        "trace.collapseDetails": "收起详情",
        "trace.collapseRuns": "收起运行列表",
        "trace.copyJson": "复制 Trace JSON",
        "trace.copyJsonShort": "复制 JSON",
        "trace.copyPath": "复制 Trace 路径",
        "trace.copySpanJson": "复制 span JSON",
        "trace.delete": "删除 Trace",
        "trace.deleted": "Trace 已删除: {traceId}",
        "trace.deleteConfirm": "删除 Trace「{traceId}」?",
        "trace.details": "详情",
        "trace.duration": "耗时",
        "trace.empty": "暂无执行 Trace",
        "trace.error": "错误",
        "trace.events": "事件",
        "trace.extension": "扩展",
        "trace.gotoDefinition": "跳转到定义",
        "trace.gotoDefinitionLine": "跳转到定义第 {line} 行",
        "trace.noEvents": "暂无事件",
        "trace.noStructuredPayload": "暂无结构化 payload",
        "trace.noTraces": "暂无 Trace",
        "trace.output": "输出",
        "trace.params": "参数",
        "trace.plugin": "插件",
        "trace.pluginAction": "插件动作",
        "trace.pluginInput": "插件输入",
        "trace.pluginResult": "插件结果",
        "trace.raw": "原始数据",
        "trace.recording": "记录中",
        "trace.request": "请求",
        "trace.resizeDetails": "调整 Trace 详情宽度",
        "trace.resizeRuns": "调整 Trace 运行列表宽度",
        "trace.resolvedConfig": "解析后的配置",
        "trace.response": "响应",
        "trace.result": "结果",
        "trace.runAll": "运行全部",
        "trace.running": "运行中",
        "trace.runs": "运行",
        "trace.runUnit": "运行单元",
        "trace.runUnitWithId": "运行 {unitId}",
        "trace.save": "保存 Trace",
        "trace.saved": "Trace 已保存: {traceId}",
        "trace.saveFailed": "Trace 保存失败: {message}",
        "trace.saveFailedMissingDocument": "Trace 保存失败: 缺少文档路径",
        "trace.showDetails": "显示详情",
        "trace.showRuns": "显示运行列表",
        "trace.sidecar": "Sidecar",
        "trace.sidecarCall": "Sidecar 调用",
        "trace.sidecarEnsure": "Sidecar 准备",
        "trace.sidecarParams": "Sidecar 参数",
        "trace.sidecarResult": "Sidecar 结果",
        "trace.span": "Span",
        "trace.start": "开启 Trace",
        "trace.stop": "停止 Trace",
        "trace.title": "Trace",
        "trace.traceRun": "Trace 运行",
        "trace.unit": "单元",
        "trace.waitingEvents": "等待执行事件",
        "trace.waterfall": "Waterfall",
        "watch.add": "添加",
        "watch.addButton": "监控",
        "watch.adding": "添加中",
        "watch.addWatch": "添加监控",
        "watch.closeAdd": "关闭添加监控",
        "watch.collapseDetails": "收起监控详情",
        "watch.collapseDetailsTitle": "收起详情",
        "watch.column": "监控项",
        "watch.counts": "{watches} 个监控 / {points} 个变化点",
        "watch.detail.change": "变化",
        "watch.detail.currentValue": "当前值",
        "watch.detail.diff": "Diff",
        "watch.detail.previousValue": "上一个值",
        "watch.detailTab.diff": "Diff",
        "watch.detailTab.meta": "元信息",
        "watch.detailTab.values": "值",
        "watch.details": "详情",
        "watch.empty": "添加监控项以追踪 output 变化。",
        "watch.error.noActiveSession": "没有可用的 Engine 会话",
        "watch.error.requiresUnitExpression": "Output 监控需要一个 unit 表达式",
        "watch.expressionLabel": "监控表达式",
        "watch.expressionPlaceholder": "unit.output.path",
        "watch.includePartial": "partial",
        "watch.inspectPoint": "查看 {label} 在 {time} 的变化",
        "watch.meta.event": "事件",
        "watch.meta.path": "路径",
        "watch.meta.unit": "Unit",
        "watch.newer": "较新",
        "watch.noActiveDocument": "没有活动文档",
        "watch.older": "较早",
        "watch.pointTitle": "{time} {summary}",
        "watch.remove": "删除监控",
        "watch.removeAria": "删除 {label}",
        "watch.resizeDetails": "调整监控详情面板宽度",
        "watch.resizeDetailsTitle": "调整详情宽度",
        "watch.resizeLabelColumn": "调整监控项列宽",
        "watch.resizeLabelColumnTitle": "调整监控列宽",
        "watch.showInWatches": "在监控面板中显示",
        "watch.suggestion.arrayIndex": "数组索引",
        "watch.suggestion.valueRoot": "值根节点",
        "watch.summary.arrayChanged": "数组变化 ({count})",
        "watch.summary.arrayLength": "数组长度 {previous} -> {next}",
        "watch.summary.failed": "失败: {error}",
        "watch.summary.initial": "初始 {value}",
        "watch.summary.objectChanged": "对象已变化",
        "watch.summary.objectKeys": "对象键 {parts}",
        "watch.timelineHelp": "从左到右表示变化顺序，点表示值发生变化。",
        "watch.value.array": "数组({count})",
        "watch.value.object": "对象({count})",
        "sidecarPanel.empty": "暂无已注册 Sidecar",
        "sidecarPanel.cloudSource": "Cloud Sidecar",
        "sidecarPanel.filter.all": "全部 Sidecar",
        "sidecarPanel.filter.cloud": "Cloud Sidecar",
        "sidecarPanel.filter.local": "本地 Sidecar",
        "sidecarPanel.noMatching": "没有匹配的 Sidecar",
        "sidecarPanel.searchPlaceholder": "搜索 Sidecar...",
        "sidecarPanel.shutdown": "停止",
        "sidecarSource.cloud": "Cloud Sidecar",
        "sidecarSource.cloud.tooltip": "通过云端 Sidecar endpoint 远程运行",
        "sidecarSource.detail.command": "命令",
        "sidecarSource.detail.deployedVersion": "部署版本",
        "sidecarSource.detail.endpoint": "RPC Endpoint",
        "sidecarSource.detail.healthUrl": "健康检查地址",
        "sidecarSource.detail.host": "主机",
        "sidecarSource.detail.manifestUrl": "Manifest 地址",
        "sidecarSource.detail.provider": "服务商",
        "sidecarSource.detail.sourceId": "源 ID",
        "sidecarSource.detail.sourceUrl": "源地址",
        "sidecarSource.detail.transport": "传输",
        "sidecarSource.detail.type": "类型",
        "sidecarSource.local": "本地 Sidecar",
        "sidecarSource.local.tooltip": "作为本地 Sidecar 进程运行",
        "vscodeWebview.config.apply": "应用",
        "vscodeWebview.config.applyAndRun": "应用并运行",
        "vscodeWebview.config.discard": "放弃修改",
        "vscodeWebview.config.visual": "可视化",
        "vscodeWebview.emptyPreview": "打开包含 Magic MD definitions 的 Markdown 文件后即可预览。",
        "vscodeWebview.previewWidth.full": "全宽",
        "vscodeWebview.previewWidth.medium": "中等 (48rem)",
        "vscodeWebview.previewWidth.prose": "阅读宽度 (65ch)",
        "vscodeWebview.previewWidth.wide": "宽屏 (64rem)",
        "vscodeWebview.sidecarCallTimedOut": "Sidecar 调用超时",
        "mcpDetail.clearLogs": "清除日志",
        "mcpDetail.annotation.destructive": "破坏性",
        "mcpDetail.annotation.readOnly": "只读",
        "mcpDetail.clients.all": "全部客户端",
        "mcpDetail.clients.connected": "已连接客户端",
        "mcpDetail.clients.empty": "没有客户端连接。配置 Claude Desktop、Cursor 或其他 MCP 客户端后即可连接。",
        "mcpDetail.clients.filterPlaceholder": "筛选客户端...",
        "mcpDetail.clients.startHint": "启动 MCP Server 后可查看已连接客户端。",
        "mcpDetail.clients.stateless": "无状态请求",
        "mcpDetail.clients.status.connected": "已连接",
        "mcpDetail.clients.status.disconnected": "已断开",
        "mcpDetail.clients.title": "客户端",
        "mcpDetail.clients.unknown": "未知客户端",
        "mcpDetail.filterPlaceholder": "按工具或方法名过滤...",
        "mcpDetail.info.clients": "客户端",
        "mcpDetail.info.endpoint": "Endpoint",
        "mcpDetail.info.notStarted": "（未启动）",
        "mcpDetail.info.prompts": "Prompts",
        "mcpDetail.info.protocol": "协议",
        "mcpDetail.info.resources": "资源",
        "mcpDetail.info.serverName": "Server 名称",
        "mcpDetail.info.tools": "工具",
        "mcpDetail.info.transport": "传输",
        "mcpDetail.info.version": "版本",
        "mcpDetail.logs.empty": "没有匹配的日志。",
        "mcpDetail.logs.logId": "日志 ID",
        "mcpDetail.logs.method": "方法",
        "mcpDetail.logs.noDetails": "没有捕获到请求参数或返回内容。",
        "mcpDetail.logs.noParams": "这条请求没有捕获到参数。",
        "mcpDetail.logs.noResponse": "没有捕获到返回内容。",
        "mcpDetail.logs.params": "JSON-RPC 参数",
        "mcpDetail.logs.request": "请求日志",
        "mcpDetail.logs.requestId": "请求 ID",
        "mcpDetail.logs.response": "JSON-RPC 返回",
        "mcpDetail.logs.responseSize": "返回大小",
        "mcpDetail.logs.responseStatus": "HTTP",
        "mcpDetail.logs.responseTruncated": "返回内容已截断",
        "mcpDetail.logs.session": "Session",
        "mcpDetail.logs.startHint": "启动 MCP Server 后可查看请求日志。",
        "mcpDetail.logs.status.error": "错误",
        "mcpDetail.logs.status.pending": "进行中",
        "mcpDetail.logs.status.success": "成功",
        "mcpDetail.logs.timestamp": "时间",
        "mcpDetail.overview": "概览",
        "mcpDetail.prompts.empty": "没有注册 Prompt。",
        "mcpDetail.prompts.startHint": "启动 MCP Server 后可查看注册的 Prompt。",
        "mcpDetail.resources.empty": "没有注册资源。",
        "mcpDetail.resources.startHint": "启动 MCP Server 后可查看注册的资源。",
        "mcpDetail.resource.template": "template",
        "mcpDetail.serverSubtitle": "MCP Server — Model Context Protocol",
        "mcpDetail.status.error": "错误",
        "mcpDetail.status.running": "运行中",
        "mcpDetail.status.start": "启动",
        "mcpDetail.status.starting": "启动中...",
        "mcpDetail.status.stop": "停止",
        "mcpDetail.status.stopped": "已停止",
        "mcpDetail.status.stopping": "停止中...",
        "mcpDetail.table.req": "必填",
        "mcpDetail.tool.noParams": "无参数",
        "mcpDetail.tool.paramsSummary": "{required} 必填，共 {total} 个",
        "mcpDetail.tools.empty": "没有注册工具。",
        "mcpDetail.tools.other": "其他",
        "mcpDetail.tools.startHint": "启动 MCP Server 后可查看注册的工具。",
        "sessionDetail.activeSessions": "活动会话",
        "sessionDetail.connectedAt": "连接于 {time}",
        "sessionDetail.connectedClients": "已连接 MCP 客户端",
        "sessionDetail.definitions": "定义",
        "sessionDetail.executionOrder": "执行顺序",
        "sessionDetail.forBlocks": "For 块",
        "sessionDetail.forOutputs": "For 输出",
        "sessionDetail.headerDescription": "活动 Engine 会话；每个会话对应一个打开的 Markdown 文档。",
        "sessionDetail.innerDefinitions": "{count} 个内部定义",
        "sessionDetail.iterations": "{count} 次迭代",
        "sessionDetail.loadingState": "正在加载会话状态...",
        "sessionDetail.mcpClientCount": "{count} 个 MCP 客户端",
        "sessionDetail.noSessions": "没有会话。打开 Markdown 文件并执行插件后会创建会话。",
        "sessionDetail.openFile": "打开文件",
        "sessionDetail.outputs": "输出",
        "sessionDetail.sessionBadge": "会话",
        "sessionDetail.sessionCount": "{count} 个会话",
        "sessionDetail.sessions": "会话",
        "sessionDetail.time.hoursAgo": "{count} 小时前",
        "sessionDetail.time.justNow": "刚刚",
        "sessionDetail.time.minutesAgo": "{count} 分钟前",
        "sessionDetail.totalIterations": "总迭代次数",
        "workspace.action.addRoot": "添加根目录",
        "workspace.action.close": "关闭工作区",
        "workspace.action.removeBookmark": "删除书签",
        "workspace.action.removeFromWorkspace": "从工作区移除",
        "workspace.action.save": "保存工作区",
        "workspace.action.unstar": "取消收藏",
        "workspace.addRootDialog": "添加工作区根目录",
        "workspace.bookmarks": "书签",
        "workspace.empty.bookmarks": "暂无工作区书签",
        "workspace.empty.folders": "当前没有工作区根目录",
        "workspace.empty.starred": "暂无收藏文件或文件夹",
        "workspace.notBound": "未绑定工作区",
        "workspace.rootRemoved": "根目录已从工作区移除",
        "workspace.rootAdded": "已添加根目录: {name}",
        "workspace.saved": "已保存工作区配置",
        "workspace.stats.bookmarks": "书签",
        "workspace.stats.dirty": "未保存",
        "workspace.stats.folders": "根目录",
        "workspace.stats.openFiles": "打开文件",
        "workspace.stats.starred": "收藏",
        "workspace.starred": "收藏",
        "workspace.title": "工作区配置",
        "sidecarDetail.action.debug": "调试这个能力",
        "sidecarDetail.action.openSettings": "打开设置",
        "sidecarDetail.action.shutdown": "关闭",
        "sidecarDetail.action.start": "启动",
        "sidecarDetail.action.startToDebug": "启动 Sidecar 后调试",
        "sidecarDetail.activeCapabilities": "活动能力",
        "sidecarDetail.boundPlugins": "绑定插件",
        "sidecarDetail.calling": "调用中...",
        "sidecarDetail.capabilities.empty": "没有匹配的能力。",
        "sidecarDetail.capabilities.examples": "示例",
        "sidecarDetail.capabilities.filterPlaceholder": "筛选能力...",
        "sidecarDetail.capabilities.info": "信息",
        "sidecarDetail.capabilities.noParams": "无参数",
        "sidecarDetail.capabilities.noSelection": "选择左侧能力后查看参数和调试调用。",
        "sidecarDetail.capabilities.returns": "返回",
        "sidecarDetail.capabilities.tabs": "能力详情",
        "sidecarDetail.cloudConfigured": "已配置",
        "sidecarDetail.cloudNotConfigured": "未配置",
        "sidecarDetail.cloudNotConfiguredHint": "Cloud Sidecar endpoint 尚未配置。请打开设置填写 endpoint。",
        "sidecarDetail.cloudSource": "Cloud Sidecar",
        "sidecarDetail.configuration": "配置",
        "sidecarDetail.debug": "调试",
        "sidecarDetail.detailTitle": "Sidecar 详情",
        "sidecarDetail.enabledDescription": "允许当前 Sidecar 自动启动并参与运行时调用。",
        "sidecarDetail.fsEnabledDescription": "内置文件系统 Sidecar，始终启用。",
        "sidecarDetail.invalidJson": "参数不是有效 JSON",
        "sidecarDetail.notRunningHint": "未运行。绑定插件执行时会自动启动。",
        "sidecarDetail.overview": "概览",
        "sidecarDetail.params": "参数",
        "sidecarDetail.protocol": "协议",
        "sidecarDetail.runtimeStatus": "运行状态",
        "sidecarDetail.send": "发送",
        "sidecarDetail.sourceInfo": "来源信息",
        "toc.collapseAll": "全部折叠",
        "toc.empty": "当前文档没有可显示的大纲",
        "toc.expandAll": "全部展开",
        "toc.tooltip.content": "Content 第 {line} 行",
        "toc.tooltip.for": "For 第 {line} 行",
        "toc.tooltip.import": "Import 第 {line} 行",
        "toc.tooltip.line": "第 {line} 行",
        "toc.tooltip.use": "Use 第 {line} 行",
        "toolbar.theme.dark": "切换到深色主题",
        "toolbar.theme.light": "切换到浅色主题",
        "toolbar.toggleConfigSidebar": "切换配置侧边栏",
        "toolbar.toggleSidebar": "切换侧边栏",
        "toolbar.view.editor": "编辑器",
        "toolbar.view.preview": "预览",
        "toolbar.view.split": "分栏",
        "useBind.addBinding": "添加绑定",
        "useBind.bindableCount": "{count} 可绑定",
        "useBind.dependencyBinding": "依赖绑定",
        "useBind.importedDefinitions": "导入定义",
        "useBind.localDefinitions": "本地定义",
        "useBind.noExternalRefs": "源定义无外部 $ref 依赖，无需绑定",
        "useBind.pluginLabel": "插件: {name}",
        "useBind.selectPlaceholder": "选择...",
        "useBind.sourceDependencies": "源定义依赖",
        "useBind.sourceRefPlaceholder": "源引用...",
        "useBind.targetDefinitionPlaceholder": "目标定义...",
        "contentBlockWrapper.configTitle": "内容实例配置",
        "snapshot.confirmDelete": "确认删除",
        "snapshot.confirmDeleteMessage": "确定要删除此快照吗？此操作不可撤销。",
        "snapshot.confirmRestore": "确认恢复",
        "snapshot.confirmRestoreMessage": "此操作将覆盖当前文件内容，不可撤销。",
        "snapshot.confirmRestoreTitle": "确认恢复",
        "snapshot.delete": "删除",
        "snapshot.deleting": "删除中...",
        "snapshot.restore": "恢复",
        "snapshot.restoring": "恢复中...",
        "snapshot.status.deleteFailed": "快照删除失败",
        "snapshot.status.deleted": "快照已删除",
        "snapshot.status.restored": "快照已恢复",
        "snapshot.status.restoredWithPreSnapshot": "快照已恢复，显示恢复前的快照内容",
        "meta.domain.document": "文档配置",
        "meta.domain.module": "模块配置",
        "meta.domain.output": "输出配置",
        "meta.domain.snapshot": "快照配置",
        "meta.dragTitle": "拖动移动配置窗",
        "meta.exports": "导出符号 (exports)",
        "meta.moving": "移动中",
        "meta.noDefinitions": "文档中暂无定义",
        "meta.otherExports": "其他导出",
        "meta.config.external": "外部存储",
        "meta.config.externalDesc": "整个 Config 写入 <doc>.magic-md/configs/ 目录，Markdown 中仅保留 __external stub",
        "meta.config.inline": "内联（默认）",
        "meta.config.inlineDesc": "完整 Config 保留在 Markdown 的 config 围栏中",
        "meta.config.storageMode": "Config 存储模式 (mode)",
        "meta.output.external": "外部存储",
        "meta.output.externalDesc": "Output 写入 .magic-md/outputs/ 目录，文档内仅保留摘要 stub",
        "meta.output.inline": "内联（默认）",
        "meta.output.inlineDesc": "Output 完整内联在 markdown 围栏中",
        "meta.output.storageMode": "存储模式 (mode)",
        "meta.snapshot.enable": "启用文档快照",
        "meta.snapshot.keepCount": "最多保留条数",
        "meta.snapshot.keepDays": "保留天数",
        "meta.snapshot.keepTagged": "带标签的快照不被自动清理",
        "meta.snapshot.mode.manual": "仅手动",
        "meta.snapshot.mode.manualDesc": "只通过按钮 / 命令打快照",
        "meta.snapshot.mode.off": "关闭",
        "meta.snapshot.mode.offDesc": "禁用整篇文档的快照",
        "meta.snapshot.mode.onSave": "保存时自动",
        "meta.snapshot.mode.onSaveDesc": "保存文档时自动快照（也可手动）",
        "meta.snapshot.retention": "保留策略 (retention)",
        "meta.snapshot.retentionHint": "快照始终保存完整文件内容。未声明 retention 不做自动清理。",
        "meta.snapshot.triggerMode": "触发模式 (mode)",
        "meta.symbol.content": "content",
        "meta.symbol.contentTemplate": "content/template",
        "debug.analyzing": "分析中...",
        "debug.diagnostics": "诊断 ({count})",
        "debug.empty": "运行文档后可在全局依赖图中选择执行单元",
        "debug.executionOrder": "执行顺序",
        "debug.globalDependencyGraph": "全局依赖图",
        "debug.graphAria": "依赖图，点击执行单元查看调试详情",
        "debug.legend": "图例",
        "debug.legend.content": "content 块",
        "debug.legend.for": "for 循环",
        "debug.legend.import": "import 模块",
        "debug.noUnits": "暂无执行单元",
        "debug.position": "第 {index} / {total}",
        "debug.viewUnitDetails": "查看 {id} 调试详情",
        "scope.maxDepthExceeded": "超过最大嵌套深度 ({max})",
        "push.confirmPairing": "确认配对",
        "push.connectedDevice": "已连接设备",
        "push.connecting": "正在连接...",
        "push.continueScanning": "继续扫描中...",
        "push.disconnect": "断开连接",
        "push.enterPairingCode": "输入 Play 上显示的配对码",
        "push.error.cannotConnect": "无法连接到 Play 设备",
        "push.noDevicesFound": "未发现 Play 设备",
        "push.paired": "已配对",
        "push.playDevice": "Play 设备",
        "push.push": "推送",
        "push.pushCurrentDocument": "推送当前文档",
        "push.realtimeSyncing": "实时同步中",
        "push.rescan": "重新扫描",
        "push.scanHint": "在 Play 端点击「同步内容」后扫描",
        "push.searchingDevices": "正在搜索设备...",
        "push.searchingLan": "搜索局域网设备中...",
        "push.sending": "发送中",
        "push.sent": "已推送",
        "push.startRealtimeSync": "开启实时同步",
        "push.status.connectedTo": "已连接到 {name}",
        "push.status.connectionFailed": "设备连接失败",
        "push.status.disconnected": "设备已断开连接",
        "push.status.disconnectFailed": "断开连接失败",
        "push.status.documentPushed": "文档已推送",
        "push.status.pushFailed": "推送失败",
        "push.status.startSyncFailed": "启动同步失败",
        "push.status.stopSyncFailed": "停止同步失败",
        "push.status.syncStarted": "同步已启动",
        "push.status.syncStopped": "同步已停止",
        "push.stopRealtimeSync": "停止实时同步",
        "push.sync": "同步",
        "push.syncing": "同步中",
        "push.toPlay": "推送到 Play",
        "push.verifying": "验证中...",
        "assetRefs.copyCode": "复制代码内容",
        "assetRefs.copyFailed": "复制失败",
        "assetRefs.copySuccess": "已复制",
        "assetRefs.unsafePath": "不安全 asset 路径：{ref}",
        "publish.error.defaultDocumentOutDir": "无法解析当前文档的默认 publish 目录",
        "publish.error.defaultFolderOutDir": "无法解析当前文件夹的默认 publish 目录",
        "publish.error.previousStartStale": "上一次发布启动未完成，已允许重新发布。",
        "publish.log.folderCancelled": "文件夹发布已取消: {path}",
        "publish.log.folderCompleted": "文件夹发布完成 ({path}): {built} 页构建, {cached} 页缓存, {failed} 页失败",
        "publish.log.folderFailed": "文件夹发布失败 ({path}): {message}",
        "publish.log.folderStart": "开始文件夹发布: {path}",
        "publish.log.folderStartFailed": "文件夹发布启动失败: {message}",
        "publish.log.randomPort": "随机",
        "publish.log.siteCancelled": "站点发布已取消",
        "publish.log.siteCompleted": "站点发布完成: {built} 页构建, {cached} 页缓存, {failed} 页失败",
        "publish.log.siteCompletedTask": "站点发布完成 (taskId: {taskId})",
        "publish.log.siteFailed": "站点发布失败: {message}",
        "publish.log.siteFailedTask": "站点发布失败 (taskId: {taskId}): {message}",
        "publish.log.siteServerStart": "启动站点服务器: {path} (端口 {port})",
        "publish.log.siteServerStarted": "站点服务器已启动: {url}",
        "publish.log.siteServerStartFailed": "站点服务器启动失败: {message}",
        "publish.log.siteServerStopped": "站点服务器已停止",
        "publish.log.siteStart": "开始站点发布: {path}",
        "publish.log.siteStartFailed": "站点发布启动失败: {message}",
        "publish.log.taskCompleted": "任务完成 (taskId: {taskId})",
        "publish.log.taskFailed": "任务失败 (taskId: {taskId}): {message}",
        "publish.log.taskStarted": "任务已启动 (taskId: {taskId})",
        "publish.logPrefix": "发布",
        "publish.progress.cancelled": "已取消",
        "publish.progress.completed": "发布完成",
        "publish.progress.folderCompleted": "文件夹发布完成",
        "publish.progress.pendingExpired": "发布启动已过期",
        "publish.progress.siteCompleted": "站点发布完成",
        "publish.progress.startingDocument": "正在启动发布...",
        "publish.progress.startingFolder": "正在启动文件夹发布...",
        "publish.progress.startingSite": "正在启动站点发布...",
        "publish.status.documentRunning": "该文档正在发布中",
        "publish.status.folderRunning": "该文件夹正在发布中",
        "publish.status.startFailedCheckStatus": "发布启动失败，请检查 publish.status.json",
        "publish.status.started": "发布已启动，可在 publish package 查看状态",
        "engineStub.configureEngine": "Engine 未连接。请在设置中配置 Engine 连接。",
        "engineStub.explainCannotExplain": "无法解释 {targetId}",
        "engineStub.explainUnavailable": "Engine 未连接，无法生成 explain 结果。",
        "engineStub.noRuntimeSession": "当前没有可用的运行时会话。",
        "engineStub.offlineTitle": "Engine 未连接",
        "engineConnector.cancelled": "连接已取消",
        "engineConnector.cannotConnectEndpoint": "无法连接到 Engine: {endpoint}",
        "engineConnector.connectingCloud": "正在连接云端 Engine...",
        "engineConnector.connectingEndpoint": "正在连接 Engine {endpoint}...",
        "engineConnector.disconnected": "Engine 连接已断开",
        "engineConnector.endpointRequired": "请先设置 Engine 地址",
        "engineConnector.preparing": "正在准备连接...",
        "engineConnector.statusUnavailable": "无法获取 Engine 状态",
        "settingsService.targetWriteUnsupported": "当前连接不支持该设置目标的写入",
        "externalOpeners.openWithCursor": "用 Cursor 打开",
        "externalOpeners.openWithSystem": "用系统默认应用打开",
        "externalOpeners.openWithVSCode": "用 VSCode 打开",
        "externalOpeners.openWithZed": "用 Zed 打开",
        "externalOpeners.revealInFolder": "在文件夹中显示",
        "explorerReveal.located": "已定位到 Explorer",
        "previewWidth.customWithPx": "自定义 {width}px",
        "publishPreview.artifactMissing": "未找到发布产物，请先发布该文档",
        "publishPreview.markdownOnly": "只有 Markdown 文档支持发布预览",
        "publishPreview.opened": "已打开发布预览",
        "scopeVariables.loopIndex": "\"{each}\" 的当前迭代索引（从 0 开始）",
        "scopeVariables.loopVariable": "循环变量 \"{each}\"，遍历 {source}",
        "scopeVariables.templateInput": "模板输入",
        "scopeVariables.templateParamFromWith": "模板参数 — 通过 with={} 传入",
        "previewLogic.exportHint.current": "当前导出：{preview}{suffix}",
        "previewLogic.exportHint.more": " 等 {count} 个",
        "previewLogic.filter.excludeHint": "\"{name}\" 已被 exclude 排除；移除 exclude 或改用可见符号。",
        "previewLogic.filter.pickEmptyHint": "该符号不在 pick 列表中；加入 pick 或改用可见符号。",
        "previewLogic.filter.pickVisibleHint": "pick 当前可见：{preview}{suffix}",
        "previewLogic.issue.importDocumentDisabled.hint": "如果只想渲染导出的符号，请使用 ::render[{targetId}/symbol]。",
        "previewLogic.issue.importDocumentDisabled.message": "::render[{targetId}] 要渲染整篇导入文档，需要在对应 ::import 上添加 document=\"true\"。",
        "previewLogic.issue.importDocumentDisabled.title": "导入文档未启用",
        "previewLogic.issue.importDocumentNotResolved.hint": "运行对应 import 后会显示整篇导入文档。",
        "previewLogic.issue.importDocumentNotResolved.message": "::render[{targetId}] 需要先运行 ::import ns=\"{targetId}\" 来生成 document snapshot。",
        "previewLogic.issue.importDocumentNotResolved.title": "导入文档快照未生成",
        "previewLogic.issue.importError.hint": "修复导入源文件或重新运行 import。",
        "previewLogic.issue.importError.message": "::import ns=\"{namespace}\" 执行失败：{message}",
        "previewLogic.issue.importError.title": "导入执行失败",
        "previewLogic.issue.importNotResolved.hint": "运行对应 import 后会恢复可渲染符号和输出。",
        "previewLogic.issue.importNotResolved.message": "::render[{targetId}] 需要先解析 ::import ns=\"{namespace}\"。",
        "previewLogic.issue.importNotResolved.title": "导入尚未解析",
        "previewLogic.issue.importSymbolFiltered.message": "::render[{targetId}] 被 ::import ns=\"{namespace}\" 的 {filter} 规则过滤，当前 import 不会导出该符号。",
        "previewLogic.issue.importSymbolFiltered.title": "导入符号被过滤",
        "previewLogic.issue.importSymbolMissing.hint": "检查源文档的 ::meta[module].exports，或改成正确的 \"{publicName}\" 名称。",
        "previewLogic.issue.importSymbolMissing.message": "::render[{targetId}] 在 ::import ns=\"{namespace}\" 的导出中不存在。",
        "previewLogic.issue.importSymbolMissing.title": "导入符号未导出",
        "previewLogic.issue.importSymbolNotRestored.hint": "重新运行对应 import，或检查导入缓存是否过期。",
        "previewLogic.issue.importSymbolNotRestored.message": "::render[{targetId}] 已在导入缓存中登记，但当前 Preview 没有恢复出可渲染实例。",
        "previewLogic.issue.importSymbolNotRestored.title": "导入符号未恢复",
        "previewLogic.issue.inlineImportDocument.hint": "把 render 移到单独一行，或渲染具体导出符号。",
        "previewLogic.issue.inlineImportDocument.message": "::render[{targetId}] 渲染整篇导入文档时必须独占一行。",
        "previewLogic.issue.inlineImportDocument.title": "导入文档只支持块渲染",
        "previewLogic.issue.unknownDefinition.hint": "检查 ID 拼写，或先声明对应的 ::define / ::content / ::for。",
        "previewLogic.issue.unknownDefinition.message": "::render[{targetId}] 没有找到同名 definition、content、for 或导入文档。",
        "previewLogic.issue.unknownDefinition.title": "渲染目标不存在",
        "previewLogic.issue.unknownNamespace.hint": "先添加 ::import{from=\"...\" ns=\"{namespace}\"}，或改成已有命名空间。",
        "previewLogic.issue.unknownNamespace.message": "::render[{targetId}] 引用了未导入的命名空间 \"{namespace}\"。",
        "previewLogic.issue.unknownNamespace.title": "命名空间未导入",
        "syntax.summary.bindItems": "bind {count} 项",
        "syntax.summary.completedPartial": "已完成 {succeeded}/{total}",
        "syntax.summary.concurrency": "并发 {count}",
        "syntax.summary.configItems": "配置 {count} 项",
        "syntax.summary.configStorageMode": "配置默认：{mode}",
        "syntax.summary.contentBlock": "内容块",
        "syntax.summary.contentRunning": "内容执行中",
        "syntax.summary.domainConfigItems": "{domain} 配置 {count} 项",
        "syntax.summary.executionResult": "执行结果",
        "syntax.summary.exports": "导出 {count} 个符号",
        "syntax.summary.generated": "已生成 {count} 项",
        "syntax.summary.generatedPartial": "已生成 {succeeded}/{total} 项",
        "syntax.summary.importAll": "导入全部符号",
        "syntax.summary.importAllExcept": "导入全部，排除 {count} 个",
        "syntax.summary.importPicked": "导入 {count} 个符号",
        "syntax.summary.importResolved": "已解析 {count} 个符号",
        "syntax.summary.importResolving": "正在解析导入",
        "syntax.summary.inProgress": "进行中 {current}/{total}",
        "syntax.summary.instantiatedFrom": "已从 {source} 实例化",
        "syntax.summary.instantiating": "实例化中",
        "syntax.summary.iterate": "遍历 {value}",
        "syntax.summary.iterationsCompleted": "已完成 {count} 次迭代",
        "syntax.summary.jsonError": "⚠ JSON 错误",
        "syntax.summary.lines": "{count} 行",
        "syntax.summary.moduleConfigItems": "模块配置 {count} 项",
        "syntax.summary.patchItems": "patch {count} 项",
        "syntax.summary.publishTarget": "发布目标 {target}",
        "syntax.summary.query": "查询 {value}",
        "syntax.summary.read": "读取 {value}",
        "syntax.summary.refs": "{count} 个引用",
        "syntax.summary.renameItems": "重命名 {count} 个",
        "syntax.summary.request": "请求 {value}",
        "syntax.summary.runPlugin": "执行 {pluginName}",
        "syntax.summary.runningWithSummary": "{summary} · 执行中",
        "syntax.summary.template": "模板",
        "syntax.summary.templateRunning": "模板执行中",
        "syntax.summary.use": "使用 {value}",
        "syntax.summary.withItems": "with {count} 项",
        "syntax.widget.comment.default": "注释",
        "syntax.widget.comment.editRaw": "点击编辑原始注释",
        "syntax.widget.content.clearError": "清除 content 错误 ({id})",
        "syntax.widget.content.editInputs": "编辑 content inputs ({id})",
        "syntax.widget.content.hideInlineRender": "隐藏内联渲染 ({id})",
        "syntax.widget.content.kind.content": "内容",
        "syntax.widget.content.kind.template": "模板",
        "syntax.widget.content.run": "运行 content ({id})",
        "syntax.widget.content.showInlineRender": "显示内联渲染 ({id})",
        "syntax.widget.content.stop": "停止 content ({id})",
        "syntax.widget.define.clearError": "清除执行错误 ({id})",
        "syntax.widget.define.configure": "配置 \"{pluginName}\" ({id})",
        "syntax.widget.define.editTemplateInputs": "编辑模板输入 ({id})",
        "syntax.widget.define.hideInlineRender": "隐藏 \"{pluginName}\" 的内联渲染 ({id})",
        "syntax.widget.define.pin": "固定 \"{pluginName}\" ({id})",
        "syntax.widget.define.run": "运行 \"{pluginName}\" ({id})",
        "syntax.widget.define.showInlineRender": "显示 \"{pluginName}\" 的内联渲染 ({id})",
        "syntax.widget.define.stop": "停止 \"{pluginName}\" ({id})",
        "syntax.widget.drag.move": "拖动以移动",
        "syntax.widget.drag.moveNamed": "拖动以移动 {label}",
        "syntax.widget.for.clearError": "清除 for 循环错误 ({id})",
        "syntax.widget.for.editInputs": "编辑 for inputs ({id})",
        "syntax.widget.for.hideInlineRender": "隐藏内联渲染 ({id})",
        "syntax.widget.for.run": "运行 for 循环 ({id})",
        "syntax.widget.for.showInlineRender": "显示内联渲染 ({id})",
        "syntax.widget.for.stop": "停止 for 循环 ({id})",
        "syntax.widget.import.clearError": "清除 import 错误 ({namespace})",
        "syntax.widget.import.run": "运行 import \"{namespace}\" from \"{source}\"",
        "syntax.widget.import.stop": "停止 import \"{namespace}\"",
        "syntax.widget.meta.configure": "配置 {domain}",
        "syntax.widget.meta.snapshotDocument": "立即快照整个文档",
        "syntax.widget.use.clearError": "清除 use 错误 ({id})",
        "syntax.widget.use.configurePlugin": "配置 \"{pluginName}\" ({id})",
        "syntax.widget.use.configureSource": "配置{sourceLabel} ({id})",
        "syntax.widget.use.contentInstance": "内容实例",
        "syntax.widget.use.editInputs": "编辑 use inputs ({id})",
        "syntax.widget.use.hideInlineRender": "隐藏内联渲染 ({id})",
        "syntax.widget.use.pin": "固定 \"{pluginName}\" ({id})",
        "syntax.widget.use.run": "运行 {sourceLabel} ({id})",
        "syntax.widget.use.showInlineRender": "显示内联渲染 ({id})",
        "syntax.widget.use.stop": "停止 {sourceLabel} ({id})",
        "syntax.widget.use.useInstance": "use 实例",
        "completion.contentBody": "内容正文",
        "completion.contentDefinition": "内容定义",
        "completion.definition": "定义",
        "completion.definitionWithPlugin": "定义：{pluginName}",
        "completion.documentAssetsPackage": "文档资源包",
        "completion.forLoop": "For 循环",
        "completion.forOutput": "For 输出",
        "completion.useInstance": "Use 实例",
        "completion.useOutput": "Use 输出",
        "intelligence.findReferences": "查找引用 ({count})",
        "intelligence.jumpTo": "跳转到 {id}",
        "intelligence.predecessors": "{id} 的前置依赖",
        "intelligence.preferred": "推荐",
        "intelligence.rename": "重命名 {id}",
        "intelligence.run": "运行 {id}",
        "intelligence.successors": "{id} 的后续依赖",
        "refResolution.assetMissing": "资源不存在",
        "refResolution.assetPathInvalid": "资源路径无效",
        "refResolution.assetPathMissing": "资源不存在：{path}",
        "refResolution.contentMissing": "内容不存在",
        "refResolution.definitionMissing": "定义不存在",
        "refResolution.error": "执行失败",
        "refResolution.loopVariable": "循环变量",
        "refResolution.loopVariablePath": "循环变量路径：{path}",
        "refResolution.pathMissing": "路径不存在：{path}",
        "refResolution.pending": "未运行",
        "refResolution.running": "执行中…",
        "refResolution.scopeVariable": "作用域变量",
        "refResolution.scopeVariablePath": "作用域变量路径：{path}",
        "refResolution.unitMissing": "unit 不存在",
        "refResolution.variableMissing": "变量不存在",
        "refResolution.variablePathMissing": "变量路径不存在：{path}",
        "syntax.fence.jsonParseFailed": "JSON 解析失败：{message}",
        "welcome.commandPaletteHint": "按 ⌘⇧P 打开命令面板",
        "welcome.recentWorkspaces": "最近工作区",
        "welcome.removeRecent": "从最近项目中移除",
        "welcome.removeRecentNamed": "从最近项目中移除 {name}",
        "welcome.subtitle": "面向可执行文档的工作台",
        "execution.circularDependency": "循环依赖",
        "sessionSync.conflictCopyTitle": "{title}（冲突副本）",
        "sessionSync.conflictRecovered": "{title} 已被其他客户端更新。你的本地编辑已保留为 {copyTitle}。"
    },
    "engineIntelligence": {
        "completion.closeFor.detail": "关闭 for 循环块",
        "completion.bodyPath": "{name} · .body",
        "completion.chooseImportedSymbol.documentation": "输入 {namespace}/<ID> 选择导入符号，然后根据类型继续 `.output.` 或 `.body`。",
        "completion.collapsedDefault.detail": "默认折叠",
        "completion.collapsedDefault.documentation": "只显示渲染标题，直到用户展开。",
        "completion.compatAlias.documentation": "兼容别名，等价于 \"{target}\"。",
        "completion.configKey": "配置键",
        "completion.configPatch.detail": "配置补丁",
        "completion.configPatch.documentation": "浅合并到源定义的 config。",
        "completion.configMetadata.detail": "配置元数据",
        "completion.configMetadata.documentation": "声明文档级配置参数。",
        "completion.content.detail": "定义可复用内容",
        "completion.content.documentation": "插入可复用 Markdown 内容定义块。\n\n```\n::content[contentId]\nTemplate content...\n::\n```",
        "completion.contentBody": "内容正文",
        "completion.contentDefinition": "内容定义",
        "completion.contentDefinition.documentationShort": "内容定义 \"{id}\"。",
        "completion.contentDefinitionFrom": "内容定义（来自 {source}）",
        "completion.contentMember": "内容成员 · {kind}",
        "completion.contentTemplate": "内容模板",
        "completion.contentTemplate.detail": "定义内容模板",
        "completion.contentTemplateAttr.documentation": "将此内容块标记为可通过 $ref{input/field} 接收外部数据的模板。",
        "completion.currentDirectory": "当前目录",
        "completion.currentDirectory.documentation": "从当前文档目录导入",
        "completion.define.detail": "定义插件实例",
        "completion.define.documentation": "插入带 config 围栏的 `::define` 块。\n\n```\n::define[id]{plugin=\"plugin-name\"}\n```config\n{}\n```\n::\n```",
        "completion.define.insertDetail": "插入定义块",
        "completion.defineOutputAttr.documentation": "控制此定义的输出存储方式。`external` 写入外部文件；`inline` 保留在文档内，并覆盖文档级 ::meta[output]。",
        "completion.defineTemplateAttr.documentation": "将此定义标记为可在 config 中通过 $ref{input/field} 接收参数的模板。",
        "completion.dependencyRebind.detail": "依赖重绑定",
        "completion.dependencyRebind.documentation": "替换 $ref{} 内的源 ID 为新 ID。",
        "completion.dependencyRebindTarget.detail": "依赖重绑定目标",
        "completion.directoryMatch": "目录匹配",
        "completion.documentAssets.detail": "文档 Assets 包",
        "completion.documentAssets.documentation": "引用当前 Markdown 文档旁边的 assets 包：$ref{assets/path/to/file}。",
        "completion.disableSnapshots.detail": "禁用快照",
        "completion.enableSnapshots.detail": "启用快照",
        "completion.endFor.detail": "结束 for 循环",
        "completion.expandedDefault.detail": "默认展开",
        "completion.expandedDefault.documentation": "文档打开时展开此块渲染。",
        "completion.exportContentDefinition.documentation": "导出内容定义 \"{id}\"。",
        "completion.exportPluginDefinition.documentation": "导出插件定义 \"{id}\"。",
        "completion.exportUse.documentation": "导出 ::use[{id}] 物化后的符号。",
        "completion.exportUseWithPublicName.documentation": "用公开名称导出 ::use[{id}] 物化后的符号（格式：localName:publicName）。",
        "completion.exportWithPublicName.documentation": "用公开名称导出 \"{id}\"（格式：localName:publicName）。",
        "completion.exportedSymbols.detail": "导出符号",
        "completion.exportedSymbols.documentation": "声明此模块导出的符号，例如 `[\"id1\", \"id2:alias\"]`。",
        "completion.externalOutput.detail": "外部输出",
        "completion.externalOutput.documentation": "将所有输出数据存储到 `.magic-md/outputs/`，文档中只保留轻量引用。适合包含大量输出数据的文档。",
        "completion.for.detail": "遍历数据源",
        "completion.for.documentation": "插入 `::for` 块，遍历某个 definition 输出中的数组。\n\n```\n::for[loopId]{each=\"item\" of=\"$ref{sourceId.output.items}\"}\n...\n::endfor\n```",
        "completion.for.insertDetail": "遍历数据源",
        "completion.forConcurrency.documentation": "并发执行数量。",
        "completion.forEach.documentation": "循环变量名，例如 item、repo 或 row。",
        "completion.forLimit.documentation": "最大迭代次数。",
        "completion.forLoop": "For 循环",
        "completion.forOf.documentation": "数据源，使用 $ref{id.output.path} 引用数组。",
        "completion.forOffset.documentation": "跳过前 N 项。",
        "completion.forTemplate": "For 模板",
        "completion.forTemplateAttr.documentation": "将此循环标记为可通过 $ref{input/field} 接收参数的模板。",
        "completion.from": "来自 {source}",
        "completion.fromSource": "<- {source}",
        "completion.getContentOutput.documentation": "获取内容定义 \"{id}\" 的执行输出。",
        "completion.getMarkdownBody.documentation": "获取内容定义 \"{id}\" 的 Markdown 正文文本。",
        "completion.higherParentDirectory": "更上级目录",
        "completion.higherParentDirectory.documentation": "跳转到更上级目录",
        "completion.import.detail": "从其他模块导入符号",
        "completion.import.documentation": "插入 `::import` 指令，从另一个文件导入定义。\n\n```\n::import{from=\"./file.md\" ns=\"alias\"}\n```",
        "completion.importDocument.documentation": "缓存导入文档快照，使 ::render[ns]:: 可以渲染整个导入文档。",
        "completion.importExternal.detail": "导入外部模块",
        "completion.importExclude.documentation": "排除指定符号（逗号分隔）。",
        "completion.importFrom.documentation": "源文件路径（相对路径）。",
        "completion.importNamespace.documentation": "命名空间；默认由文件名推断。",
        "completion.importPathDirectory": "导入路径目录",
        "completion.importPick.documentation": "只导入指定符号（逗号分隔）。",
        "completion.importRename.documentation": "用 old:new 格式重命名符号（逗号分隔）。",
        "completion.importableMarkdownFile": "可导入的 Markdown 文件",
        "completion.importedAssets.documentation": "引用导入命名空间 `{namespace}` 的 assets：$ref{{ref}}。",
        "completion.importedBody": "{name}（已导入） · .body",
        "completion.importedContentDefinition.documentation": "导入的内容定义 \"{id}\"。",
        "completion.importedDefinition.documentation": "导入的定义 \"{id}\"。",
        "completion.importedDocument": "导入文档 · {source}",
        "completion.importedDocumentFrom": "导入文档（来自 {source}）",
        "completion.importedFrom": "导入自 {source}",
        "completion.importedOutput": "{name}（已导入） · .output",
        "completion.insertRef.documentation": "插入 $ref{{ref}}",
        "completion.localDefinition.documentation": "本地定义 \"{id}\"。",
        "completion.loopItem.documentation": "循环 `{forId}` 的当前项变量。",
        "completion.loopScoped": "{name} · 循环 {scope}",
        "completion.loopField.detail": "从样本推断的循环变量字段",
        "completion.loopIndex.detail": "循环索引（从 0 开始）",
        "completion.loopIndex.documentation": "循环 `{forId}` 的当前索引。",
        "completion.loopVariableFor": "循环变量 · {forId}",
        "completion.loopVariable.detail": "循环变量（当前项）",
        "completion.loopVariableReference.detail": "循环变量引用",
        "completion.markdownFile": "Markdown 文件",
        "completion.markdownFileMatch": "Markdown 文件匹配",
        "completion.metaConfig.detail": "文档配置",
        "completion.metaConfig.documentation": "插入 `::meta[config]` 块，声明文档级配置参数。",
        "completion.metaModule.detail": "声明模块元数据",
        "completion.metaModule.documentation": "插入 `::meta[module]` 块，声明导出的符号。\n\n```\n::meta[module]\n```config\n{ \"exports\": [\"symbol1\", \"symbol2\"] }\n```\n::\n```",
        "completion.metaOutput.detail": "外置输出",
        "completion.metaOutput.documentation": "插入 `::meta[output]` 块，将文档输出数据外置到 `.magic-md/outputs/`。适合 SQL 查询结果、API 响应等大型输出。",
        "completion.metaSnapshot.detail": "版本快照策略",
        "completion.metaSnapshot.documentation": "插入 `::meta[snapshot]` 块，控制文档级快照行为。\n\n- `mode`: `manual`、`on-save` 或 `off`\n- `retention`: 保留策略（`keepCount` / `keepDays`）",
        "completion.moduleMetadata.detail": "模块元数据",
        "completion.moduleMetadata.documentation": "声明模块导出的符号和命名空间。",
        "completion.namedTemplate": "{name} · 模板",
        "completion.namespaceFrom": "命名空间 {namespace}（来自 {source}）",
        "completion.namespaceFromSource": "命名空间（来自 {source}）",
        "completion.option": "{name} 选项",
        "completion.optional.detail": "可选",
        "completion.outputAttr.documentation": "覆盖文档级 ::meta[output] 的输出存储方式：external=文件外置，inline=内联。",
        "completion.outputFieldsPending.detail": "运行后才会出现输出字段",
        "completion.outputFieldsPending.documentation": "当前没有运行时输出，也没有可用的静态 outputSchema。",
        "completion.outputPath": "{name} · .output",
        "completion.outputPolicy.detail": "输出存储策略",
        "completion.outputPolicy.documentation": "声明文档输出如何存储。设置 `{ \"mode\": \"external\" }` 可将输出数据外置到 `.magic-md/outputs/`，减少文档体积。",
        "completion.outputStorageMode.detail": "输出存储模式",
        "completion.outputStorageMode.documentation": "控制输出存储。`\"external\"` 会将输出移到独立文件，减少文档体积。",
        "completion.parentDirectory": "上级目录",
        "completion.parentDirectory.documentation": "从上级目录导入",
        "completion.parentLoopVariable.documentation": "引用父循环 `{forId}` 的当前项变量，例如 `{example}`。",
        "completion.parameterInjection.detail": "参数注入（高级）",
        "completion.parameterInjection.documentation": "向源定义注入额外参数。",
        "completion.rawMarkdown.detail": "原始 Markdown",
        "completion.rawMarkdownCompatibility.detail": "原始 Markdown（兼容别名）",
        "completion.render.insertDetail": "插入 render 标签",
        "completion.renderDefinition.detail": "渲染 definition 输出",
        "completion.renderDefinition.documentation": "插入 `::render[id]::` 标签，显示某个 definition 的渲染结果。",
        "completion.renderLoopOutput.documentation": "渲染循环 \"{id}\" 的输出。",
        "completion.refEmpty.detail": "引用其他定义或内容块",
        "completion.refEmpty.documentation": "插入空的 $ref{} 引用，然后继续输入 ID、.output. 或 .body。",
        "completion.referenceContentBody.documentation": "引用内容定义 \"{id}\"；继续输入 `.body` 访问原始 Markdown。",
        "completion.referenceContentMemberOutput.documentation": "引用内容包成员 \"{id}\"；继续输入 `.output.` 访问成员输出字段。",
        "completion.referenceImportedContentBody.documentation": "引用导入内容 \"{id}\"；继续输入 `.body` 访问原始 Markdown。",
        "completion.referenceImportedOutput.documentation": "引用导入定义 \"{id}\"；继续输入 `.output.` 访问输出字段。",
        "completion.referenceLoopOutput.documentation": "引用循环 \"{id}\" 的执行输出；继续输入 \".output.\" 访问迭代结果。",
        "completion.referenceOutput.documentation": "引用 \"{id}\"（{source}）；继续输入 `.output.` 访问输出字段。",
        "completion.referenceUseOutput.documentation": "引用 ::use 实例 \"{id}\"；继续输入 `.output.` 访问输出字段。",
        "completion.required.detail": "必填",
        "completion.scopedOutput.detail": "作用域输出",
        "completion.selectUnit.documentation": "选择 unit `{id}` 并插入 `{ref}` 作为身份引用。",
        "completion.snapshotDisabled.documentation": "禁用文档级快照。",
        "completion.snapshotEnabled.documentation": "总开关。为 false 时，此文档的所有快照都会禁用。",
        "completion.snapshotEnabled.detail": "已启用",
        "completion.snapshotManual.detail": "仅手动",
        "completion.snapshotManual.documentation": "仅在手动触发时创建快照。",
        "completion.snapshotMode.detail": "触发模式",
        "completion.snapshotMode.documentation": "控制何时创建快照：`manual`、`on-save` 或 `off`。",
        "completion.snapshotOff.detail": "关闭",
        "completion.snapshotOnSave.detail": "保存时 + 手动",
        "completion.snapshotOnSave.documentation": "每次保存文档时创建快照，同时仍允许手动快照。",
        "completion.snapshotRetention.detail": "保留策略",
        "completion.snapshotRetention.documentation": "快照保留策略。`{ \"keepCount\": 50 }` 保留最近 50 个快照；`{ \"keepDays\": 30 }` 保留最近 30 天。",
        "completion.staticPath": "{type} · 静态",
        "completion.symbolInNamespace.documentation": "命名空间 \"{namespace}\" 中的 \"{symbol}\"。",
        "completion.templateParameter.detail": "模板参数",
        "completion.templateParameter.documentation": "模板参数 $ref{input/{param}}",
        "completion.templateParameters.detail": "模板参数（{params}）",
        "completion.templateParameters.documentation": "注入模板参数值，并替换 $ref{input/xxx}。",
        "completion.templateParametersList.documentation": "模板参数：{params}",
        "completion.templateTarget.documentation": "{kind} \"{id}\" 是模板，不会直接执行。::render[] 只显示模板占位内容；渲染前请先用 ::use 实例化。",
        "completion.typeImportedReference.documentation": "输入 {namespace}/<ID> 引用导入的定义。",
        "completion.unitIdentity.detail": "Unit 身份引用",
        "completion.unitIdentity.documentation": "引用可控 unit 的身份：$ref{unit/<unitId>}。用于 control 插件 unitId 等字段。",
        "completion.use.detail": "引用并配置实例",
        "completion.use.documentation": "插入 `::use` 块，引用某个定义并覆盖其配置。\n\n```\n::use[instanceId]{from=\"sourceId\"}\n```config\n{ \"key\": \"override\" }\n```\n::\n```",
        "completion.use.instanceDetail": "引用并配置实例",
        "completion.useTemplateFrom": "使用模板 · <- {source}",
        "completion.useOutputAsLoopSource.documentation": "使用 \"{id}\" 的输出作为循环数据源。",
        "completion.withAlias": "{name} · 带别名",
        "diagnostic.assetsFileMissing": "Assets 文件不存在：{path}",
        "diagnostic.changeTo": "改为 \"{suggestion}\"",
        "diagnostic.circularDependency": "检测到循环依赖：{path}",
        "diagnostic.duplicateDefinition": "definition ID \"{id}\" 重复（首次定义在第 {line} 行）",
        "diagnostic.importMissingFrom": "::import 缺少必需属性 from=\"\"",
        "diagnostic.importedNamespaceMissing": "导入命名空间不存在：{namespace}",
        "diagnostic.invalidAssetPath": "assets 引用路径无效：\"{path}\"",
        "diagnostic.invalidJson": "JSON 无效",
        "diagnostic.invalidJsonConfig": "config 块中的 JSON 无效：{message}",
        "diagnostic.invalidOutputAttr": "output 属性值 \"{value}\" 无效，仅支持 \"external\" 或 \"inline\"",
        "diagnostic.metaOutputInvalidMode": "::meta[output] mode \"{mode}\" 无效，目前仅支持 \"external\"",
        "diagnostic.metaOutputMissingMode": "::meta[output] 需要 \"mode\" 字段，例如 { \"mode\": \"external\" }",
        "diagnostic.missingConfig": "::define 块 \"{id}\" 没有 config 块",
        "diagnostic.missingTemplateParam": "::{kind}[{id}] 缺少必需模板参数 \"{param}\"（来自 {source}）",
        "diagnostic.refPathNotFound": "在 \"{id}\" 的输出中找不到 $ref 路径 \"{path}\"",
        "diagnostic.unclosedContent": "content 定义块 \"{id}\" 未闭合，缺少结束行 \"::\"",
        "diagnostic.unclosedDefine": "::define 块 \"{id}\" 未闭合，缺少结束行 \"::\"",
        "diagnostic.unclosedMeta": "::meta 块未闭合，缺少结束行 \"::\"",
        "diagnostic.unclosedUse": "::use 块 \"{id}\" 未闭合，缺少结束行 \"::\"",
        "diagnostic.unknownDefinition": "未知 definition \"{id}\"",
        "diagnostic.unknownDefinitionSuggestion": "未知 definition \"{id}\"，是不是 \"{suggestion}\"？",
        "diagnostic.unknownPlugin": "未知插件 \"{plugin}\"",
        "diagnostic.unknownPluginSuggestion": "未知插件 \"{plugin}\"，是不是 \"{suggestion}\"？",
        "hover.config": "配置",
        "hover.configOverrides": "配置覆盖",
        "hover.contentDefinitionNotFound": "找不到内容定义",
        "hover.contentLines": "行内容",
        "hover.contentNoOutput": "内容没有输出",
        "hover.definitionDoesNotExist": "Definition 不存在",
        "hover.documentRenderEnabled": "document：已启用 `::render[ns]::`",
        "hover.executed": "已执行",
        "hover.executionOutputSection": "执行输出区段",
        "hover.exports": "导出",
        "hover.failed": "失败",
        "hover.filePath": "文件路径",
        "hover.from": "来自",
        "hover.importedDocument": "导入文档",
        "hover.importedDocumentSnapshotMissing": "尚未生成导入文档快照。",
        "hover.importedFrom": "导入自",
        "hover.importedNamespaceMissing": "导入命名空间不存在",
        "hover.innerOutputs": "内部输出",
        "hover.invalidAssetPath": "asset 路径无效",
        "hover.iterations": "次迭代",
        "hover.iterationsTotal": "次迭代总计",
        "hover.jsonConfigSection": "JSON 配置区段",
        "hover.lines": "行",
        "hover.notRun": "未运行",
        "hover.output": "输出",
        "hover.outputManualEdits": "下次运行会覆盖手动编辑",
        "hover.pathNotFound": "路径不存在",
        "hover.requiresDocumentImport": "需要在对应的 `::import` 上设置 `document=\"true\"`。",
        "hover.requiresDocumentImportRun": "需要 `document=\"true\"` 且导入已完成运行，才能解析此命名空间的 assets。",
        "hover.serializationError": "（序列化错误）",
        "hover.sourceUnresolved": "来源尚未解析或物化。",
        "hover.targetNotFound": "目标不存在",
        "hover.unknownPlugin": "未知插件",
        "symbols.configOverride": "配置覆盖",
        "symbols.executionOutput": "执行输出",
        "symbols.jsonConfig": "JSON 配置",
        "symbols.metadataConfig": "元数据配置",
        "template.default": "默认值",
        "template.description": "描述",
        "template.options": "选项",
        "template.required": "必填",
        "template.title": "标题",
        "template.type": "类型"
    },
    "play": {
        "app.action.menu": "菜单",
        "app.action.publishPreview": "发布预览",
        "app.action.run": "运行",
        "app.action.stop": "停止",
        "app.action.toc": "目录",
        "app.dialog.allFiles": "所有文件",
        "app.dialog.openMarkdownFile": "打开 Markdown 文件",
        "app.error.dropMarkdownOnly": "请拖入 Markdown 文件 (.md)",
        "app.error.openExternalFailed": "外部打开失败",
        "app.error.openFileFailed": "打开文件失败",
        "app.error.openPublishPreviewFailed": "打开发布预览失败",
        "app.error.publishPreviewArtifactMissing": "未找到发布产物，请先在桌面端发布该文档",
        "app.error.publishPreviewGatewayRequired": "远程发布预览需要先连接 Engine Gateway",
        "app.error.publishPreviewMissingPath": "当前文档没有文件路径，无法打开发布预览",
        "app.error.publishPreviewReadFailed": "无法读取发布预览文件",
        "app.error.readFileFailed": "读取文件失败",
        "app.error.refreshFailed": "刷新失败",
        "app.runAllProgress": "执行中 {current}/{total}",
        "common.cancel": "取消",
        "common.close": "关闭",
        "common.refresh": "刷新",
        "common.retry": "重试",
        "definitionConfig.applyChanges": "应用修改",
        "definitionConfig.discard": "撤销修改",
        "definitionConfig.noDefinition": "未找到定义",
        "definitionConfig.prompt.directoryPath": "请输入目录路径：",
        "definitionConfig.prompt.filePath": "请输入文件路径：",
        "definitionConfig.visualEditor": "可视化",
        "drawer.closeTab": "关闭 {title}",
        "drawer.emptyFiles": "暂无打开的文件",
        "drawer.engineConnected": "Engine 已连接",
        "drawer.engineDisconnected": "Engine 未连接",
        "drawer.error.openFileFailed": "无法打开文件，可能已被移动或删除",
        "drawer.error.openWorkspaceFailed": "无法打开工作区，可能已被移动或没有权限",
        "drawer.goHome": "返回首页",
        "drawer.home": "首页",
        "drawer.openTabs": "已打开",
        "drawer.plugins": "插件",
        "drawer.recentFiles": "最近打开",
        "drawer.remove": "移除",
        "drawer.removeNamed": "移除 {name}",
        "drawer.tool.connect": "连接",
        "drawer.tool.local": "本地",
        "drawer.tool.open": "打开",
        "drawer.tool.search": "搜索",
        "drawer.tool.sync": "同步",
        "drawer.tool.workspace": "工作区",
        "drawer.workspaceHistory": "历史工作区",
        "engineConnector.connect": "连接",
        "engineConnector.connected": "已连接",
        "engineConnector.connectFailed": "无法连接到 Engine Gateway",
        "engineConnector.connectFailedWithDetail": "连接失败: {detail}",
        "engineConnector.connecting": "正在连接...",
        "engineConnector.clearGatewayAddress": "清空 Gateway 地址",
        "engineConnector.disconnect": "断开连接",
        "engineConnector.disconnected": "未连接",
        "engineConnector.discoveredGateways": "局域网内的 Gateway",
        "engineConnector.discoveryEmpty": "未发现 Gateway，也可以在下方手动输入地址。",
        "engineConnector.discoveryFailed": "发现失败: {detail}",
        "engineConnector.discoveryRefresh": "刷新",
        "engineConnector.discoveryScanning": "正在搜索局域网...",
        "engineConnector.gatewayAddress": "Gateway 地址",
        "engineConnector.runOnDesktopPrefix": "在电脑上运行",
        "engineConnector.runOnDesktopSuffix": "启动 Gateway",
        "engineConnector.subtitle": "连接到 Engine Gateway 以启用执行和 AI 功能",
        "engineConnector.title": "Engine 连接",
        "execution.completed": "执行完成",
        "execution.completedWithDuration": "完成 ({duration})",
        "execution.detail": "详情",
        "execution.failed": "执行失败",
        "errorBoundary.clearPluginCacheAndReload": "清除插件缓存并重新加载",
        "errorBoundary.reload": "重新加载",
        "errorBoundary.title": "出了点问题",
        "home.action.connectEngine": "连接 Engine",
        "home.action.connectEngineDetail": "选择或扫描设备",
        "home.action.openDocument": "打开文档",
        "home.action.openDocumentDetail": "选择本机 Markdown 文件",
        "home.action.search": "搜索",
        "home.action.searchRequiresEngine": "连接 Engine 后可用",
        "home.action.sync": "同步",
        "home.action.syncDetail": "推送内容",
        "home.action.workspace": "工作区",
        "home.action.workspaceDetail": "浏览已连接 Engine 的文件",
        "home.action.workspaceSearch": "工作区搜索",
        "home.empty.description": "打开文件或连接 Engine 后继续",
        "home.empty.title": "暂无文档",
        "home.error.mdspaceGatewayRequired": "打开 mdspace 需要先连接 Engine Gateway",
        "home.error.openFileFailed": "无法打开文件",
        "home.openTabs": "已打开",
        "home.recentFiles": "最近打开",
        "home.source.local": "本地",
        "home.source.publishPreview": "发布预览",
        "home.source.push": "推送",
        "home.source.remote": "远程",
        "htmlPreview.openExternal": "外部打开",
        "fileList.closeTab": "关闭 {title}",
        "fileList.pushDocument": "推送文档",
        "fileList.title": "打开的文档",
        "pairing.cancel": "取消配对",
        "pairing.instructions": "请在 Editor 中输入以下数字完成配对",
        "pairing.requestFromPrefix": "来自",
        "pairing.requestFromSuffix": "的连接请求",
        "pairing.title": "配对码",
        "plugin.category.ai": "AI",
        "plugin.category.aiTooling": "AI 工具",
        "plugin.category.composition": "组合",
        "plugin.category.data": "数据",
        "plugin.category.database": "数据库",
        "plugin.category.devops": "DevOps",
        "plugin.category.devtool": "开发工具",
        "plugin.category.file": "文件",
        "plugin.category.fileOps": "文件操作",
        "plugin.category.git": "Git",
        "plugin.category.integration": "集成",
        "plugin.category.layout": "布局",
        "plugin.category.media": "媒体",
        "plugin.category.other": "其他",
        "plugin.category.productivity": "效率",
        "plugin.category.runtime": "运行时",
        "plugin.category.utility": "工具",
        "plugin.category.visualization": "可视化",
        "pluginManager.authorLabel": "作者：",
        "pluginManager.cached.daysAgo": "{count} 天前",
        "pluginManager.cached.hoursAgo": "{count} 小时前",
        "pluginManager.cached.label": "已缓存",
        "pluginManager.cached.minutesAgo": "{count} 分钟前",
        "pluginManager.cached.now": "刚刚",
        "pluginManager.clearCache": "清除缓存",
        "pluginManager.clearSearch": "清空搜索",
        "pluginManager.clearing": "清除中...",
        "pluginManager.empty": "暂无已加载插件",
        "pluginManager.loadedCount": "{count} 个插件已加载",
        "pluginManager.noMatches": "没有匹配的插件",
        "pluginManager.renderBlock": "块",
        "pluginManager.renderInline": "行内",
        "pluginManager.renderLabel": "渲染：",
        "pluginManager.searchPlaceholder": "搜索插件...",
        "pluginManager.title": "插件管理",
        "remoteFile.emptyDirectory": "此目录为空",
        "remoteFile.error.fetchRootsFailed": "无法获取目录列表",
        "remoteFile.error.pathOutsideRoots": "该路径不在允许的目录范围内",
        "remoteFile.error.readDirectoryFailed": "无法读取目录",
        "remoteFile.error.readFileFailed": "无法读取文件",
        "remoteFile.error.workspaceUnsupported": "当前版本不支持打开工作区文件",
        "remoteFile.goUp": "返回上级",
        "remoteFile.location": "位置",
        "remoteFile.markdownFiles": "Markdown 文件",
        "remoteFile.noAccessibleRoots": "当前网关没有暴露可访问的目录根。",
        "remoteFile.otherFiles": "其他文件",
        "remoteFile.title": "远程文件",
        "search.error.gatewayRequired": "Workspace Search 需要先连接 Engine Gateway",
        "search.error.openResultFailed": "无法打开搜索结果",
        "search.requiresEngineDescription": "Workspace Search 依赖 Gateway 扫描远程工作区文件。",
        "search.requiresEngineTitle": "需要连接 Engine",
        "store.document": "文档",
        "store.publishPreviewTitle": "{name} · 发布预览",
        "store.pushLabel": "推送",
        "sync.broadcast": "广播",
        "sync.description.live": "Editor 正在实时推送文档",
        "sync.description.off": "开启后 Editor 可发现此设备并推送文档。",
        "sync.description.waitingSelection": "在编辑器中选择此设备即可开始预览。",
        "sync.editor": "编辑器",
        "sync.localDevice": "本机",
        "sync.running": "进行中",
        "sync.servicePort": "服务端口",
        "sync.startBroadcast": "开始广播",
        "sync.status.connected": "已连接",
        "sync.status.live": "实时同步中",
        "sync.status.off": "同步未开启",
        "sync.status.waitingEditor": "等待编辑器加入",
        "sync.stopBroadcast": "停止广播",
        "sync.stopped": "已停止",
        "sync.subtitle": "开启广播后编辑器可发现此设备并推送文档",
        "sync.thisDevice": "此设备",
        "sync.title": "与编辑器同步",
        "toc.empty.description": "文档中没有发现标题",
        "toc.empty.title": "暂无目录",
        "toc.title": "目录",
        "tabBar.closeTab": "关闭 {title}",
        "viewer.connected": "已连接",
        "viewer.engineConnected": "Engine 已连接",
        "viewer.syncing": "同步中",
        "viewer.waitingPush": "等待推送",
        "workspace.folderCount": "{count} 个文件夹",
        "workspace.title": "工作区",
        "workspaceTree.loading": "正在加载工作区...",
        "workspaceTree.noWorkspace": "当前 Engine 没有打开工作区。可以通过下方“远程”选择 .mdspace。",
        "workspaceTree.openFileFailed": "无法打开文件",
        "workspaceTree.refresh": "刷新工作区"
    },
    "pluginSdk": {
        "collapsiblePre.expandAll": "全部展开",
        "collapsiblePre.expandMore": "继续展开",
        "collapsiblePre.lineCount": "{visible} / {total} 行",
        "comboSelect.noMatch": "无匹配 \"{query}\"",
        "comboSelect.noOptions": "无可用选项",
        "comboSelect.placeholder": "选择...",
        "comboSelect.search": "搜索...",
        "common.collapse": "收起",
        "common.expand": "展开",
        "continuationTarget.kind.content": "Content",
        "continuationTarget.kind.definition": "Definition",
        "continuationTarget.kind.for": "For 循环",
        "continuationTarget.kind.fragment": "片段",
        "continuationTarget.kind.importDocument": "导入文档",
        "continuationTarget.placeholder": "选择挂载内容...",
        "engineMount.requiresHost": "EngineMount 需要宿主环境",
        "jsonTree.copyAsJson": "复制为 JSON",
        "jsonTree.copyMinifiedJson": "复制紧凑 JSON",
        "jsonTree.copyPath": "复制路径",
        "jsonTree.copyValue": "复制值",
        "lsp.error.commandMissing": "未找到 {command}",
        "lsp.error.crashed": "LSP 已崩溃",
        "lsp.error.serverCrashed": "{command} 已崩溃",
        "lsp.error.serverExited": "{command} 已退出",
        "lsp.error.serverExitedWithReason": "{command} 已退出: {reason}",
        "lsp.error.sqlsMissingFts5": "sqls 缺少 FTS5 支持",
        "lsp.nextProblem": "下一个问题 (F8)",
        "lsp.noProblems": "没有问题",
        "lsp.quickFix": "快速修复",
        "lsp.quickFixShortcut": "快速修复 (Mod+.)",
        "lsp.resizeEditor": "拖动调整编辑器高度",
        "lsp.status.connected": "{label} 已连接",
        "lsp.status.connecting": "{label} 连接中",
        "lsp.status.disconnected": "LSP 未连接",
        "lsp.status.error": "{label} 异常",
        "lsp.status.off": "LSP 已关闭",
        "lsp.status.startFailed": "{label} 启动失败：{error}",
        "pty.close": "关闭终端",
        "pty.closedMessage": "[会话已关闭]",
        "pty.endedMessage": "[会话已结束]",
        "pty.livenessFailedMessage": "[会话检测失败]",
        "pty.missingSessionMessage": "[会话不存在，请重新启动终端]",
        "pty.requiresTerminalSidecar": "PTY 模式需要 terminal sidecar 支持",
        "pty.restart": "重启终端",
        "pty.status.active": "● 活跃",
        "pty.status.connecting": "◌ 连接中",
        "pty.status.ended": "○ 已结束",
        "pty.status.error": "✗ 错误",
        "pty.title": "PTY 会话",
        "referenceBrowser.declaredInputs": "已声明 input",
        "referenceBrowser.emptyImportDocument": "此导入文档没有可引用的 definition 或 content",
        "referenceBrowser.group.contentRefs": "内容引用",
        "referenceBrowser.group.documentRefs": "文档引用",
        "referenceBrowser.group.importDocuments": "导入文档",
        "referenceBrowser.group.scopeVariables": "作用域变量",
        "referenceBrowser.group.templateInputs": "模板输入",
        "referenceBrowser.group.unitIdentity": "Unit 身份",
        "referenceBrowser.inputParam": "input/ 参数",
        "referenceBrowser.invalidParamName": "参数名仅支持字母、数字、下划线和连字符",
        "referenceBrowser.noDocumentAssets": "当前文档还没有可用 assets，先在 Explorer 中添加 Assets Package 并导入文件。",
        "referenceBrowser.noImportAssets": "导入文档还没有可用 assets，先在对应文档的 Assets Package 中导入文件。",
        "referenceBrowser.noRefs": "没有可用引用",
        "referenceBrowser.noUnits": "没有可用 unit",
        "referenceBrowser.paramName": "参数名",
        "referenceBrowser.runContentForOutput": "执行此内容块后可浏览内部输出",
        "referenceBrowser.runSourceForFields": "数据源未执行 — 先运行以预览字段结构",
        "referenceBrowser.selectContent": "选择一个内容块以浏览正文或内部输出",
        "referenceBrowser.selectDefinition": "选择一个文档实例以浏览输出字段",
        "referenceBrowser.selectImportDocument": "选择一个 document import 以浏览其中的定义和内容",
        "referenceBrowser.selectRef": "选择引用…",
        "referenceBrowser.selectScopeVariable": "选择一个作用域变量以浏览字段",
        "referenceBrowser.selectSource": "选择引用来源…",
        "referenceBrowser.selectSourceFirst": "先从下拉中选择引用来源",
        "referenceBrowser.use": "使用",
        "refOrValue.switchToManual": "点击切换到手动模式",
        "refOrValue.switchToRef": "点击切换到引用模式",
        "resizableSidebar.title": "拖拽调整侧栏宽度，双击重置",
        "resizableViewport.title": "拖动调整高度"
    }
}
